<div class="page-backdrop" [class.theme-light]="theme === 'light'" [class.theme-dark]="theme === 'dark'" [style.background]="shellBackground"></div>
<div class="topbar-scroll-mask" [style.background]="shellBackground"></div>
<div class="app-shell" [class.theme-light]="theme === 'light'" [class.theme-dark]="theme === 'dark'" [class.view-dashboard]="activeView === 'dashboard'" [class.view-operations]="activeView === 'operations'" [class.view-freshdesk]="activeView === 'freshdesk'" [class.view-schedule]="activeView === 'schedule'" [class.view-satisfaction]="activeView === 'satisfaction'" [class.view-documents]="activeView === 'documents'" [class.view-metrics]="activeView === 'metrics'" [style.--page-bg]="shellBackground" [style.backgroundColor]="'transparent'" [style.backgroundImage]="'none'">
  <header class="topbar" [class.filters-open]="filtersOpen">
    <div class="brand-block">
      <button class="brand-mark brand-reset" type="button" (click)="resetAllFilters()" title="Restablecer todos los filtros">
        <img src="/logo-claro.png" alt="Claro">
      </button>
      <div class="brand-copy">
        <button class="brand-title brand-main-view brand-view-toggle" type="button" [class.active]="viewMenuOpen" (click)="toggleViewMenu()" [attr.aria-expanded]="viewMenuOpen">
          <span class="view-kicker">Vista</span>
          <span class="view-label">Paneles</span>
          <span class="view-chevron">⌄</span>
        </button>
        <div class="brand-view-menu" [class.open]="viewMenuOpen">
          <button type="button" [class.active]="activeView === 'dashboard'" (click)="selectView('dashboard')">Estado operación</button>
          <button type="button" [class.active]="activeView === 'operations'" (click)="selectView('operations')">Gestión equipos</button>
          <button type="button" [class.active]="activeView === 'satisfaction'" (click)="selectView('satisfaction')">Satisfacción</button>
          <button type="button" [class.active]="activeView === 'schedule'" (click)="selectView('schedule')">Cronograma</button>
          <button type="button" [class.active]="activeView === 'documents'" (click)="selectView('documents')">Documentos</button>
          <button type="button" [class.active]="activeView === 'metrics'" (click)="selectView('metrics')">Métricas</button>
        </div>
      </div>
      <button class="filter-segment" type="button" [class.is-hidden]="activeView !== 'dashboard' && activeView !== 'operations'" (click)="toggleFiltersPanel()" [attr.aria-expanded]="filtersOpen">
        <span>Filtros</span>
        <small *ngIf="activeChips.length">{{ activeChips.length + ' activos' }}</small>
      </button>
      <nav class="section-nav" [class.is-hidden]="activeView !== 'dashboard'" aria-label="Navegación de segmentos">
        <button type="button" (click)="scrollToSegment('estado')">Estado</button>
        <button type="button" (click)="scrollToSegment('temas')">Movimiento</button>
        <button type="button" (click)="scrollToSegment('tendencias')">Tendencias</button>
        <button type="button" (click)="scrollToSegment('tickets')">Tickets</button>
      </nav>
    </div>
    <div class="topbar-actions">
      <button class="theme-switch" type="button" [class.active]="theme === 'dark'" (click)="toggleTheme()" aria-label="Darkmode">
        <span class="theme-switch-track" aria-hidden="true"><i></i></span>
      </button>
      <button class="ghost-button" type="button" [disabled]="activeRefreshLoading" (pointerdown)="$event.stopPropagation()" (click)="refreshActiveView($event)">{{ activeRefreshLoading ? 'Recargando...' : 'Recargar' }}</button>
    </div>
  </header>

  <ng-container *ngIf="activeView === 'metrics'">
    <section class="metrics-page">
      <header class="metrics-header">
        <div class="metrics-title-block">
          <span>Centro Servicio</span>
          <h1>Métricas transversales</h1>
          <p>Lectura única para control de operación, experiencia, cronograma y documentos.</p>
        </div>
        <div class="metrics-update-block">
          <span>Estado datos</span>
          <strong>{{ statusText }}</strong>
          <small>{{ subtitle }}</small>
        </div>
      </header>

      <section class="metrics-source-strip" aria-label="Fuentes consolidadas">
        <article *ngFor="let card of metricsSourceCards" [class]="'metrics-source-card tone-' + card.tone">
          <div>
            <span>{{ card.label }}</span>
            <small>{{ card.note }}</small>
          </div>
          <strong>{{ card.value }}</strong>
        </article>
      </section>

      <section class="metrics-command-grid">
        <article class="metrics-command-card" *ngFor="let card of metricsExecutiveCards" [class]="'accent-' + card.accent">
          <span>{{ card.label }}</span>
          <strong>{{ card.value }}</strong>
          <small>{{ card.note }}</small>
        </article>
      </section>

      <section class="metrics-resolution-wide metrics-panel">
            <div class="metrics-resolution-wide-body">
              <div class="metrics-resolution-side">
                <div class="metrics-resolution-layout">
                  <div class="metrics-pie-wrap">
                    <div class="metrics-resolution-pie" [style.--same-day]="metricsResolutionSamePct + '%'" [style.--two-three]="metricsResolutionTwoThreePct + '%'" [style.--four-plus]="metricsResolutionFourPlusPct + '%'" aria-label="Distribución de tiempo de resolución">
                      <div>
                        <strong>{{ formatNumber(metricsResolutionTotal) }}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="metrics-resolution-legend">
                    <strong>{{ metricsResolutionTitle }}</strong>
                    <div *ngFor="let slice of metricsResolutionSlices" [class]="'resolution-' + slice.key">
                      <i></i>
                      <span>{{ slice.label }}</span>
                      <strong>{{ formatNumber(slice.value) }}</strong>
                      <small>{{ slice.pct }}%</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="metrics-resolution-trend" aria-label="Comportamiento de tiempo de resolución últimos 6 meses">
                <div class="metrics-resolution-trend-head">
                  <strong>Tiempo de resolución · últimos 6 meses</strong>
                  <span><i class="same"></i>Mismo día</span>
                  <span><i class="two-three"></i>2-3 días</span>
                  <span><i class="late"></i>4+ días</span>
                </div>
                <div class="metrics-resolution-trend-row" *ngFor="let point of metricsResolutionSixMonthTrend">
                  <span class="trend-month">{{ point.label }}</span>
                  <div class="resolution-trend-bar" [attr.aria-label]="point.label + ': ' + point.withinThreeDaysPct + '% dentro de 3 días'">
                    <em class="same" [style.width.%]="point.sameDayPct"><span *ngIf="point.sameDay">{{ formatNumber(point.sameDay) }}</span></em>
                    <em class="two-three" [style.width.%]="point.twoThreeDaysPct"><span *ngIf="point.twoThreeDays">{{ formatNumber(point.twoThreeDays) }}</span></em>
                    <em class="late" [style.width.%]="point.fourPlusDaysPct"><span *ngIf="point.fourPlusDays">{{ formatNumber(point.fourPlusDays) }}</span></em>
                  </div>
                  <b>{{ point.withinThreeDaysPct }}%</b>
                  <small>{{ formatNumber(point.withinThreeDays) }}/{{ formatNumber(point.total) }}</small>
                </div>
              </div>
              <div class="metrics-monthly-resolution" aria-label="Tickets recibidos por mes">
                <div class="metrics-monthly-resolution-head">
                  <strong>Recibidos por mes</strong>
                  <span><i class="resolved"></i>Resueltos</span>
                  <span><i class="unresolved"></i>No resueltos</span>
                </div>
                <button class="metrics-monthly-bar-row" type="button" *ngFor="let item of metricsMonthlyResolutionBars" [class.active]="selectedMetricsMonthKey === item.key" (click)="selectMetricsMonth(item.key)">
                  <span class="month-label">{{ item.label }}</span>
                  <div class="monthly-stacked-bar" [attr.aria-label]="item.label + ': ' + formatNumber(item.received) + ' recibidos'">
                    <div class="monthly-bar-segment resolved" [style.width.%]="item.resolvedPct">
                      <b *ngIf="item.resolved">{{ formatNumber(item.resolved) }}</b>
                    </div>
                    <div class="monthly-bar-segment unresolved" [style.width.%]="item.unresolvedPct">
                      <b *ngIf="item.unresolved">{{ formatNumber(item.unresolved) }}</b>
                    </div>
                  </div>
                  <strong class="month-total">{{ formatNumber(item.received) }}</strong>
                </button>
              </div>
              <div class="metrics-area-distribution metrics-status-distribution">
                <div class="metrics-area-pie" [style.background]="metricsResolvedPendingPieBackground" aria-label="Resueltos y pendientes">
                  <div>
                    <strong>{{ formatNumber(metricsResolvedPendingTotal) }}</strong>
                  </div>
                </div>
                <div class="metrics-area-legend">
                  <strong>{{ metricsResolvedPendingTitle }}</strong>
                  <button class="metrics-area-row" type="button" *ngFor="let slice of metricsResolvedPendingSlices" [class.active]="selectedMetricsArea === slice.label" [class.no-filter]="slice.label === 'Otras áreas'" (click)="selectMetricsArea(slice.label)">
                    <i [style.background]="slice.color"></i>
                    <span>{{ slice.label }}</span>
                    <div class="metrics-area-row-bar status-split" [style.width.%]="slice.barPct">
                      <em class="status-resolved" [style.width.%]="slice.resolvedPct"></em>
                      <em class="status-unresolved" [style.width.%]="slice.unresolvedPct"></em>
                    </div>
                    <b class="status-q">
                      <span>{{ formatNumber(slice.resolved || 0) }}</span>
                      <span>/</span>
                      <span>{{ formatNumber(slice.unresolved || 0) }}</span>
                      <span>/</span>
                      <span>{{ formatNumber(slice.value || 0) }}</span>
                    </b>
                    <small>{{ slice.pct }}%</small>
                  </button>
                </div>
              </div>
              <div class="metrics-centro-breakdown-card" aria-label="Detalle Centro de Servicio por responsable últimos 3 meses">
                <div class="metrics-centro-breakdown-head">
                  <div>
                    <strong>Centro de Servicio · últimos 3 meses</strong>
                    <span>Detalle por responsable</span>
                  </div>
                </div>
                <div class="metrics-centro-breakdown-legend">
                  <span><i class="diego"></i>Diego Astudillo</span>
                  <span><i class="maria"></i>Maria Joaquina</span>
                  <span><i class="alejandro"></i>Alejandro Muñoz</span>
                  <span><i class="rest"></i>Resto / sin grupo</span>
                  <span><i class="pending"></i>Pendientes</span>
                </div>
                <div class="metrics-centro-breakdown-rows">
                  <div class="metrics-centro-breakdown-row" *ngFor="let row of metricsCentroServicioOwnerBreakdownRows">
                    <strong>{{ row.label }}</strong>
                    <div class="metrics-centro-breakdown-bar">
                      <em *ngFor="let item of row.values" [style.width.%]="item.pct" [style.background]="item.color" [class.has-value]="item.value > 0">
                        <span *ngIf="item.value">{{ formatNumber(item.value) }}</span>
                      </em>
                    </div>
                    <b>{{ formatNumber(row.total) }}</b>
                  </div>
                </div>
              </div>
              <div class="metrics-centro-derivation-table" aria-label="Tickets derivados Centro de Servicio últimos 6 meses">
                <div class="metrics-centro-derivation-head">
                  <div>
                    <strong>Centro de Servicio · últimos 6 meses</strong>
                    <span>Participación sobre el total mensual derivado</span>
                  </div>
                  <b>{{ formatNumber(metricsCentroServicioDerivationTotal) }}</b>
                </div>
                <div class="metrics-centro-derivation-grid">
                  <span>Mes</span>
                  <span>Centro Serv. / Total mes</span>
                  <span>% gestionado</span>
                  <ng-container *ngFor="let row of metricsCentroServicioDerivationRows">
                    <strong>{{ row.label }}</strong>
                    <b class="metrics-centro-derivation-pair">
                      <span class="resolved">{{ formatNumber(row.total) }}</span>
                      <span>/</span>
                      <span>{{ formatNumber(row.monthlyTotal) }}</span>
                    </b>
                    <div class="metrics-centro-derivation-bar">
                      <em [style.width.%]="row.sharePct"></em>
                      <span>{{ row.sharePct }}%</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
      </section>

      <section class="metrics-workbench">
        <div class="metrics-side-stack">
          <div class="metrics-panel">
            <div class="metrics-panel-head">
              <span>{{ metricsSatisfactionTitle }}</span>
              <small>NPS y nota promedio</small>
            </div>
            <div class="metrics-satisfaction-stack" *ngIf="metricsSatisfactionHasData; else noMetricsSatisfaction">
              <div class="metrics-satisfaction-row" *ngFor="let row of metricsSatisfactionTrendRows">
                <span class="satisfaction-month">{{ row.label }}</span>
                <div class="metrics-satisfaction-bars">
                  <div class="metrics-satisfaction-bar nps">
                    <em [style.width.%]="row.npsPct"></em>
                    <b>NPS {{ row.nps ?? '—' }}</b>
                  </div>
                  <div class="metrics-satisfaction-bar note">
                    <em [style.width.%]="row.notePct"></em>
                    <b>Nota {{ row.average ?? '—' }}</b>
                  </div>
                  <div class="metrics-satisfaction-bar detractors">
                    <em [style.width.%]="row.detractorPct"></em>
                    <b>Det. {{ formatNumber(row.detractors) }}</b>
                  </div>
                </div>
                <div class="metrics-satisfaction-counts">
                  <strong>{{ formatNumber(row.answered) }}</strong>
                  <small>encuestas</small>
                </div>
              </div>
            </div>
            <ng-template #noMetricsSatisfaction>
              <div class="empty-state">No hay datos de satisfacción para el filtro seleccionado.</div>
            </ng-template>
          </div>
        </div>

        <article class="card chart-card trend-subcard risk-trend-subcard" style="grid-column: 1; margin-top: 0;">
          <div class="card-head">
            <div>
              <h2>Evolución de riesgos operativos</h2>
              <p>Casos de riesgo alto (críticos) de Sin interacción y Tiempo creado al cierre de cada período.</p>
              </div>
              <div class="segmented-control risk-window-toggle">
              <button
                class="segmented"
                *ngFor="let option of riskTrendWindowOptions"
                [class.active]="riskTrendWindow === option.value"
                (click)="setRiskTrendWindow(option.value)"
              >
                {{ option.label }}
              </button>
            </div>
          </div>
          <div class="trend-list trend-chart risk-trend-chart" *ngIf="riskTrendSeries.length; else noRiskTrend">
            <div class="trend-legend">
              <span><i class="dot bar-inflow"></i>Inercia: entran a crítico</span>
              <span><i class="dot bar-outflow"></i>Gestión: críticos resueltos</span>
              <span><i class="dot stock-critical"></i>Stock crítico al cierre</span>
            </div>
            <div class="trend-line-wrap">
              <svg class="trend-line-svg" viewBox="0 0 1024 240" preserveAspectRatio="none" role="img" aria-label="Evolución de riesgos operativos">
                <line class="trend-grid-line" x1="0" y1="22" x2="1024" y2="22"></line>
                <line class="trend-grid-line" x1="0" y1="84" x2="1024" y2="84"></line>
                <line class="trend-grid-line" x1="0" y1="147" x2="1024" y2="147"></line>
                <line class="trend-grid-line strong" x1="0" y1="210" x2="1024" y2="210"></line>
                <line class="risk-flow-baseline" x1="0" y1="130" x2="1024" y2="130"></line>
                
                <g class="flow-bars">
                  <ng-container *ngFor="let p of riskTrendFlowPoints">
                    <rect class="bar-inflow" [attr.x]="p.inflow.x" [attr.y]="p.inflow.y" width="10" [attr.height]="p.inflow.h" rx="2" *ngIf="p.inflow.val > 0"></rect>
                    <rect class="bar-outflow" [attr.x]="p.outflow.x" [attr.y]="p.outflow.y" width="10" [attr.height]="p.outflow.h" rx="2" *ngIf="p.outflow.val > 0"></rect>
                  </ng-container>
                </g>
                <path class="trend-area stock-critical" [attr.d]="riskTrendStockAreaPath"></path>
                <path class="trend-line stock-critical" [attr.d]="riskTrendStockPath"></path>
                <g class="stock-labels">
                  <text class="risk-stock-line-label" *ngFor="let point of riskTrendStockPoints" [attr.x]="point.labelX" [attr.y]="point.labelY" text-anchor="middle">
                    {{ formatNumber(point.value) }}
                  </text>
                </g>
                <ng-container *ngFor="let point of riskTrendStockPoints; let i = index">
                  <circle class="trend-point stock-critical" [class.selected]="isRiskTrendSelectedIndex(i)" [attr.cx]="point.x" [attr.cy]="point.y" [attr.r]="isRiskTrendSelectedIndex(i) ? 5.5 : 4"></circle>
                </ng-container>
                <g class="flow-labels">
                  <ng-container *ngFor="let p of riskTrendFlowPoints">
                    <text class="risk-flow-label inflow" [attr.x]="p.inflow.labelX" [attr.y]="p.inflow.labelY" text-anchor="middle" *ngIf="p.inflow.val > 0">+{{ formatNumber(p.inflow.val) }}</text>
                    <text class="risk-flow-label outflow" [attr.x]="p.outflow.labelX" [attr.y]="p.outflow.labelY" text-anchor="middle" *ngIf="p.outflow.val > 0">-{{ formatNumber(p.outflow.val) }}</text>
                  </ng-container>
                </g>
                <line class="trend-hover-line" *ngIf="riskTrendDetailPoint" [attr.x1]="riskTrendHoverX" y1="22" [attr.x2]="riskTrendHoverX" y2="210"></line>
                <rect class="trend-hitbox compare-hitbox" x="0" y="14" width="1024" height="210" (click)="selectRiskTrendPoint($event)"></rect>
              </svg>
              <div class="trend-axis">
                <button class="trend-axis-label" type="button" *ngFor="let point of riskTrendSeries; let i = index" [class.active]="isRiskTrendSelectedIndex(i)" (click)="selectRiskTrendIndex(i)">
                  <span>{{ riskTrendAxisLabel(point) }}</span>
                </button>
              </div>
              <div class="risk-trend-description" aria-label="Descripción del movimiento de críticos">
                <div>
                  <i class="bar-inflow"></i>
                  <strong>Inercia</strong>
                  <b>+{{ formatNumber(riskTrendDetailPoint?.flow?.inflow || 0) }}</b>
                </div>
                <div>
                  <i class="bar-outflow"></i>
                  <strong>Gestión</strong>
                  <b>-{{ formatNumber(riskTrendDetailPoint?.flow?.outflow || 0) }}</b>
                </div>
                <div>
                  <i class="stock-critical"></i>
                  <strong>Stock</strong>
                  <b>{{ formatNumber(riskTrendDetailPoint?.stock_critical || 0) }}</b>
                </div>
                <div class="risk-trend-info">
                  <strong>Lectura</strong>
                  <span>Inercia son tickets que entraron a riesgo crítico; Gestión son críticos resueltos; Stock es el inventario crítico vivo al cierre del período.</span>
                </div>
              </div>
            </div>
          </div>
          <ng-template #noRiskTrend>
            <div class="empty-state">No hay datos para la evolución de riesgos.</div>
          </ng-template>
        </article>
      </section>
    </section>
  </ng-container>

  <ng-container *ngIf="activeView === 'dashboard' || activeView === 'operations'">
  <section class="toolbar card" [class.filters-open]="filtersOpen || filtersClosing" [class.filters-closing]="filtersClosing">
    <div class="filters-panel">
    <div class="toolbar-row">
      <label class="search-box">
        <span>Buscar</span>
        <input type="search" [(ngModel)]="search" (input)="requestRefresh()" placeholder="Ticket, asunto, agente, grupo, etiqueta">
      </label>

      <div class="date-box">
        <label>
          <span>Desde</span>
          <input type="date" [(ngModel)]="fromDate" (change)="requestRefresh()">
        </label>
        <label>
          <span>Hasta</span>
          <input type="date" [(ngModel)]="toDate" (change)="requestRefresh()">
        </label>
      </div>
    </div>

    <div class="filters-grid">
      <div class="filter-box" *ngFor="let def of filterValues">
        <button class="filter-button" type="button" (click)="toggleFilter(def.key)">
          <span class="label">{{ def.label }}</span>
          <span class="count">{{ selectedCount(def.key) }}</span>
        </button>
        <div class="filter-menu" *ngIf="openFilter === def.key">
          <div class="filter-head">
            <span>Buscar en {{ def.label }}</span>
          </div>
          <input class="filter-search" type="search" [value]="filterSearch[def.key]" (input)="filterSearch[def.key] = $any($event.target).value" placeholder="Filtrar opciones">
          <div class="filter-list">
            <label class="filter-option" *ngFor="let option of filterOptions(def.key)">
              <input type="checkbox" [checked]="isSelected(def.key, option)" (change)="selectValue(def.key, option, $any($event.target).checked)">
              <span>{{ displayValue(def.key, option) }}</span>
            </label>
            <div class="empty-state" *ngIf="!filterOptions(def.key).length">Sin opciones</div>
          </div>
        </div>
      </div>
    </div>
    <div class="toolbar-actions-right">
      <button class="action-button secondary" type="button" (click)="clearFilters()">Limpiar filtros</button>
    </div>
    </div>
  </section>

  <section class="kpi-grid" *ngIf="activeView === 'dashboard'">
    <article class="kpi-card" *ngFor="let card of kpiCards" [class.clickable]="card.clickable" [class.active]="isKpiActive(card.key)" (click)="card.clickable && applyKpi(card.key)">
      <div class="title">{{ card.title }}</div>
      <div class="value">{{ card.value }}</div>
      <div class="note">{{ card.note }}</div>
    </article>
  </section>

  <section class="card monthly-panel segment-card" id="segment-estado" *ngIf="activeView === 'dashboard'">
    <div class="card-head segment-head">
      <div>
        <h2>Estado actual</h2>
      </div>
      <div class="segment-head-metrics">
        <span>{{ formatNumber(summary?.total || 0) }} tickets</span>
        <strong>{{ formatNumber(summary?.unresolved || 0) }} sin resolver</strong>
      </div>
    </div>
    <div class="monthly-layout">
      <div class="area-quadrants">
        <button class="area-quadrant" *ngFor="let item of areaTreemapItems" type="button" [ngStyle]="areaTreemapStyle(item)" [class.compact]="item.compact" [class.active]="isSummaryLabelActive('group', item.row.label)" [disabled]="item.row.label === 'Otras áreas'" [attr.title]="item.row.label + ' · ' + formatNumber(item.row.total) + ' · ' + formatPercent(item.share)" (click)="applyAreaQuadrant(item.row)">
          <div class="area-quadrant-top">
            <span>{{ item.row.label }}</span>
            <div class="area-quadrant-stat">
              <strong>{{ formatPercent(item.share) }}</strong>
              <small>{{ formatNumber(item.row.total) }} tickets</small>
            </div>
          </div>
          <div class="area-quadrant-track">
            <div class="area-quadrant-fill" [style.width.%]="item.share"></div>
          </div>
          <div class="area-quadrant-meta">
            <span>{{ formatNumber(item.row.unresolved) }} sin resolver</span>
            <span>{{ summarySlaRate(item.row) }} SLA</span>
          </div>
        </button>
        <div class="empty-state" *ngIf="!areaTreemapItems.length">Sin áreas para el filtro activo.</div>
      </div>

      <div class="monthly-side">
        <article class="monthly-mini">
          <div class="monthly-mini-head">
            <strong>Riesgo - Sin interacción</strong>
            <span>{{ formatNumber(unresolvedTotal) }} sin resolver</span>
          </div>
          <button class="age-row" *ngFor="let item of ageRows" type="button" [class.active]="isRiskActive(item.key)" (click)="applyPeriodRisk(item.key)">
            <div class="age-copy">
              <strong>{{ item.range }}</strong>
              <span>{{ item.title }}</span>
            </div>
            <div class="bar-track"><div class="bar-fill" [ngClass]="item.color" [style.width.%]="unresolvedTotal ? (item.value / unresolvedTotal) * 100 : 0"></div></div>
            <span class="age-value">{{ formatNumber(item.value) }}</span>
          </button>
        </article>

        <article class="monthly-mini">
          <div class="monthly-mini-head">
            <strong>Riesgo - Tiempo creado</strong>
            <span>{{ formatNumber(unresolvedTotal) }} sin resolver</span>
          </div>
          <button class="age-row" *ngFor="let item of createdAgeRows" type="button" [class.active]="isCreatedRiskActive(item.key)" (click)="applyCreatedPeriodRisk(item.key)">
            <div class="age-copy">
              <strong>{{ item.range }}</strong>
              <span>{{ item.title }}</span>
            </div>
            <div class="bar-track"><div class="bar-fill" [ngClass]="item.color" [style.width.%]="unresolvedTotal ? (item.value / unresolvedTotal) * 100 : 0"></div></div>
            <span class="age-value">{{ formatNumber(item.value) }}</span>
          </button>
        </article>
      </div>
    </div>
  </section>

  <section class="dashboard-grid topics-after-status" id="segment-temas" *ngIf="activeView === 'dashboard'">
    <article class="card chart-card card-span-12 topics-card segment-card">
      <div class="card-head segment-head">
        <div>
          <h2>Movimiento</h2>
          <p>Volumen total y variación contra el período anterior equivalente.</p>
        </div>
        <div class="topics-head-metrics segment-head-metrics">
          <span>{{ topics.length }} temas</span>
          <strong>{{ trendTopics.length }} al alza</strong>
        </div>
      </div>
      <div class="topics-window-bar">
        <span class="window-current">Comparación: {{ topicWindowLabel }}</span>
        <div class="topic-window-options">
          <button type="button" *ngFor="let option of topicWindowOptions" [class.active]="topicWindowDays === option.value" [disabled]="topicsLoading" (click)="setTopicWindow(option.value)">
            {{ option.label }}
          </button>
        </div>
        <span class="window-previous">Versus período anterior equivalente</span>
      </div>
      <button class="topic-clear-filter" *ngIf="isTopicScoped" type="button" (click)="clearTopicFilter()">
        Tema activo: {{ topicFilter }} · volver
      </button>
      <div class="topics-layout" *ngIf="topics.length; else noTopicsAfterStatus">
        <div class="topics-main">
          <button class="topic-tile" *ngFor="let topic of topics.slice(0, 6)" type="button" [class.active]="isTopicActive(topic)" (click)="applyTopic(topic)">
            <div class="topic-copy">
              <strong>{{ topic.label }}</strong>
              <span>{{ formatNumber(topic.value) }} tickets · {{ formatNumber(topic.recent) }} en {{ topicWindowLabel }}</span>
            </div>
            <div class="topic-trend" [ngClass]="topic.direction">
              <span>{{ topicTrendIcon(topic) }}</span>
              <strong>{{ topicTrendLabel(topic) }}</strong>
            </div>
            <div class="topic-meter">
              <i><b [style.width.%]="(topic.value / (topics[0]?.value || 1)) * 100"></b></i>
            </div>
          </button>
        </div>
        <div class="topics-side">
          <aside class="topics-rising">
            <div class="topics-rising-head">
              <span>{{ risingPanelTitle }}</span>
              <strong>{{ risingPanelCount }}</strong>
            </div>
            <div class="topics-panel-list">
              <button class="rising-topic" *ngFor="let topic of risingPanelTopics" type="button" [class.active]="isTopicActive(topic)" (click)="applyTopic(topic)">
                <span class="rise-arrow">{{ risingTopicIcon(topic) }}</span>
                <div>
                  <strong>{{ topic.label }}</strong>
                  <small>{{ risingTopicDescription(topic) }}</small>
                </div>
                <b class="rise-delta" [ngClass]="riseDeltaClass(topic)">{{ risingTopicDelta(topic) }}</b>
              </button>
              <div class="empty-state" *ngIf="!risingPanelTopics.length">
                Sin actividad relevante en el período.
              </div>
            </div>
          </aside>

          <aside class="topics-rising topics-recent">
            <div class="topics-rising-head">
              <div class="topics-rising-head-copy">
                <span>{{ recentTopicsTitle }}</span>
              </div>
              <strong>{{ formatNumber(recentTopicsWindowTotal) }}</strong>
            </div>
            <div class="topics-panel-list">
              <button class="rising-topic recent-topic" *ngFor="let topic of recentTopics" type="button" [class.active]="isTopicActive(topic)" (click)="applyTopic(topic)">
                <span class="rise-arrow recent-pill">•</span>
                <div>
                  <strong>{{ topic.label }}</strong>
                  <small>{{ formatNumber(topic.recent) }} en {{ topicWindowLabel }} · {{ formatPercent(recentTopicShare(topic)) }} del período</small>
                </div>
                <b class="recent-count">{{ formatNumber(topic.recent) }}</b>
              </button>
              <div class="empty-state" *ngIf="!recentTopics.length">
                Sin actividad reciente en el período.
              </div>
            </div>
          </aside>

          <aside class="topics-rising topics-resolved">
            <div class="topics-rising-head">
              <div class="topics-rising-head-copy">
                <span>Resueltos recientemente</span>
              </div>
              <strong>{{ formatNumber(resolvedRecentTotal) }}</strong>
            </div>
            <div class="topics-panel-list">
              <button class="rising-topic resolved-topic" *ngFor="let topic of resolvedTopics" type="button" [class.active]="isTopicActive(topic) && topicScope === 'resolved'" (click)="applyResolvedTopic(topic)">
                <span class="rise-arrow resolved-pill">✓</span>
                <div>
                  <strong>{{ topic.label }}</strong>
                  <small>{{ formatNumber(topic.recent) }} resueltos en {{ topicWindowLabel }} · {{ formatPercent(resolvedTopicShare(topic)) }} del período</small>
                </div>
                <b class="recent-count resolved-count">{{ formatNumber(topic.recent) }}</b>
              </button>
              <div class="empty-state" *ngIf="!resolvedTopics.length">
                Sin resoluciones en el período.
              </div>
            </div>
          </aside>
        </div>
      </div>
      <ng-template #noTopicsAfterStatus>
        <div class="empty-state">Sin temas.</div>
      </ng-template>
    </article>
  </section>

  <section class="card segment-card trends-segment" id="segment-tendencias" *ngIf="activeView === 'dashboard'">
    <div class="card-head segment-head">
      <div>
        <h2>Tendencias</h2>
        <p>Recibidos, resueltos, pendientes acumulados y comparación semanal.</p>
      </div>
      <div class="segment-head-metrics">
        <span>{{ level | titlecase }}</span>
        <strong>{{ weeklyComparisonMetricOptions.length }} métricas</strong>
      </div>
    </div>
    <div class="dashboard-grid trends-grid">
    <article class="card chart-card card-span-6 trend-subcard">
      <div class="card-head">
        <div>
          <h2>Tendencia de recibidos, resueltos y pendientes acumulados</h2>
          <p>Serie diaria con pendientes reales al cierre de cada período.</p>
        </div>
        <div class="trend-head-actions">
          <button class="ghost-button restore-button" *ngIf="fromDate || toDate" type="button" (click)="resetPeriodFilter()">Ver todo el período</button>
          <div class="segmented-control">
            <button class="segmented" [class.active]="level === 'dia'" (click)="setLevel('dia')">Día</button>
            <button class="segmented" [class.active]="level === 'mes'" (click)="setLevel('mes')">Mes</button>
            <button class="segmented" [class.active]="level === 'trimestre'" (click)="setLevel('trimestre')">Trimestre</button>
            <button class="segmented" [class.active]="level === 'semestre'" (click)="setLevel('semestre')">Semestre</button>
            <button class="segmented" [class.active]="level === 'anio'" (click)="setLevel('anio')">Año</button>
          </div>
        </div>
      </div>
      <div class="trend-list trend-chart" *ngIf="trendSeries.length; else noTrend">
        <div class="trend-legend">
          <span><i class="dot red"></i>Recibidos</span>
          <span><i class="dot teal"></i>Resueltos</span>
          <span><i class="dot violet"></i>Pendientes</span>
        </div>
        <div class="trend-line-wrap" (mouseleave)="clearTrendHover()">
          <svg class="trend-line-svg" [attr.viewBox]="trendLineViewBox" role="img" aria-label="Tendencia de recibidos, resueltos y pendientes acumulados">
            <line class="trend-grid-line" x1="4" y1="22" x2="716" y2="22"></line>
            <line class="trend-grid-line" x1="4" y1="84" x2="716" y2="84"></line>
            <line class="trend-grid-line" x1="4" y1="147" x2="716" y2="147"></line>
            <line class="trend-grid-line strong" x1="4" y1="210" x2="716" y2="210"></line>
            <path class="trend-area received" [attr.d]="trendAreaPath('received')"></path>
            <path class="trend-area closed" [attr.d]="trendAreaPath('closed')"></path>
            <path class="trend-area backlog" [attr.d]="trendAreaPath('backlog')"></path>
            <path class="trend-line received" [attr.d]="trendLinePath('received')"></path>
            <path class="trend-line closed" [attr.d]="trendLinePath('closed')"></path>
            <path class="trend-line backlog" [attr.d]="trendLinePath('backlog')"></path>
            <line class="trend-hover-line" *ngIf="trendActivePoint" [attr.x1]="trendHoverX" y1="22" [attr.x2]="trendHoverX" y2="210"></line>
            <rect class="trend-hitbox" x="4" y="14" width="712" height="210" (pointerdown)="startTrendPan($event)" (mousemove)="onTrendPointer($event)"></rect>
          </svg>
          <div class="trend-tooltip" *ngIf="trendActivePoint" [class.left-edge]="trendTooltipPositionClass === 'left-edge'" [class.right-edge]="trendTooltipPositionClass === 'right-edge'" [style.left.%]="trendTooltipLeftPct">
            <strong class="trend-tooltip-date">
              <span>{{ trendDateLabel(trendActivePoint) }}</span>
              <small *ngIf="trendDayLabel(trendActivePoint)">| {{ trendDayLabel(trendActivePoint) }}</small>
            </strong>
            <em>Arrastra para recorrer períodos</em>
            <button class="tooltip-metric red" type="button" (pointerdown)="$event.stopPropagation()" (click)="applyTrendMetric(trendActivePoint, 'received')"><i></i>Recibidos <b>{{ formatNumber(trendActivePoint.received) }}</b></button>
            <button class="tooltip-metric teal" type="button" (pointerdown)="$event.stopPropagation()" (click)="applyTrendMetric(trendActivePoint, 'closed')"><i></i>Resueltos <b>{{ formatNumber(trendActivePoint.closed) }}</b></button>
            <button class="tooltip-metric violet" type="button" (pointerdown)="$event.stopPropagation()" (click)="applyTrendMetric(trendActivePoint, 'backlog')"><i></i>Pendientes <b>{{ formatNumber(trendActivePoint.backlog) }}</b></button>
          </div>
          <div class="trend-axis">
            <button class="trend-axis-label" *ngFor="let point of trendAxisLabels" type="button" (click)="applyTrendSelection(point)">
              <span class="axis-date">{{ trendDateLabel(point) }}</span>
              <small class="axis-day" *ngIf="trendDayLabel(point)">| {{ trendDayLabel(point) }}</small>
            </button>
          </div>
        </div>
      </div>
      <ng-template #noTrend>
        <div class="empty-state">No hay datos para la tendencia.</div>
      </ng-template>
    </article>

    <article class="card chart-card card-span-6 trend-subcard">
      <div class="card-head">
        <div>
          <h2>Comparativa semanal últimos 3 períodos</h2>
          <p>Tendencia semanal por período según la métrica seleccionada.</p>
        </div>
        <div class="segmented-control weekly-metric-toggle">
          <button
            class="segmented"
            *ngFor="let option of weeklyComparisonMetricOptions"
            [class.active]="weeklyComparisonMetric === option.key"
            (click)="weeklyComparisonMetric = option.key; clearWeeklyComparisonHover()"
          >
            {{ option.label }}
          </button>
        </div>
      </div>
      <div class="trend-list trend-chart weekly-comparison-chart" *ngIf="weeklyComparisonSeries.length; else noWeeklyComparison">
        <div class="trend-legend">
          <span *ngFor="let serie of weeklyComparisonSeries; let i = index">
            <i class="dot" [class.period-a]="i === 0" [class.period-b]="i === 1" [class.period-c]="i === 2"></i>
            {{ displayValue('trend', serie.label) }}
          </span>
        </div>
        <div class="trend-line-wrap">
          <svg class="trend-line-svg" [attr.viewBox]="trendLineViewBox" role="img" aria-label="Comparativa semanal de los últimos 3 períodos">
            <line class="trend-grid-line" x1="4" y1="22" x2="716" y2="22"></line>
            <line class="trend-grid-line" x1="4" y1="84" x2="716" y2="84"></line>
            <line class="trend-grid-line" x1="4" y1="147" x2="716" y2="147"></line>
            <line class="trend-grid-line strong" x1="4" y1="210" x2="716" y2="210"></line>
            <ng-container *ngFor="let serie of weeklyComparisonSeries; let i = index">
              <path class="trend-area period-a" *ngIf="i === 0" [attr.d]="weeklyComparisonAreaPath(serie)"></path>
              <path class="trend-area period-b" *ngIf="i === 1" [attr.d]="weeklyComparisonAreaPath(serie)"></path>
              <path class="trend-area period-c" *ngIf="i === 2" [attr.d]="weeklyComparisonAreaPath(serie)"></path>
              <path class="trend-line period-a" *ngIf="i === 0" [attr.d]="weeklyComparisonPath(serie)"></path>
              <path class="trend-line period-b" *ngIf="i === 1" [attr.d]="weeklyComparisonPath(serie)"></path>
              <path class="trend-line period-c" *ngIf="i === 2" [attr.d]="weeklyComparisonPath(serie)"></path>
            </ng-container>
            <line class="trend-hover-line" *ngIf="weeklyComparisonActiveAxis" [attr.x1]="weeklyComparisonHoverX" y1="22" [attr.x2]="weeklyComparisonHoverX" y2="210"></line>
            <rect class="trend-hitbox compare-hitbox" x="4" y="14" width="712" height="210" (mousemove)="onWeeklyComparisonPointer($event)" (mouseleave)="clearWeeklyComparisonHover()"></rect>
          </svg>
          <div class="trend-tooltip compare-tooltip" *ngIf="weeklyComparisonActiveAxis" [class.left-edge]="weeklyComparisonTooltipPositionClass === 'left-edge'" [class.right-edge]="weeklyComparisonTooltipPositionClass === 'right-edge'" [style.left.%]="weeklyComparisonTooltipLeftPct">
            <strong>{{ weeklyComparisonActiveAxis.label }}</strong>
            <em>Comparativa por período</em>
            <span class="tooltip-metric" *ngFor="let row of weeklyComparisonTooltipRows" [class.red]="row.color === 'red'" [class.teal]="row.color === 'teal'" [class.violet]="row.color === 'violet'">
              <i></i>{{ displayValue('trend', row.label) }} <b>{{ formatNumber(row.value) }}</b>
            </span>
          </div>
          <div class="trend-axis">
            <span class="trend-axis-label static" *ngFor="let item of weeklyComparisonAxis">
              <span>{{ item.label }}</span>
            </span>
          </div>
        </div>
      </div>
      <ng-template #noWeeklyComparison>
        <div class="empty-state">No hay datos para comparar períodos.</div>
      </ng-template>
    </article>
    </div>
  </section>

  <section class="operations-page" *ngIf="activeView === 'operations'">
    <div class="operations-hero">
      <div>
        <span class="operations-eyebrow">Centro de servicio</span>
        <h1>Gestión equipos de trabajo</h1>
        <p>Visión ejecutiva del rendimiento del centro de servicio.</p>
      </div>
    </div>

    <div class="topics-window-bar operations-period-bar operations-period-top">
      <span class="window-current">{{ topicWindowLabel }}</span>
      <div class="topic-window-options">
        <button type="button" *ngFor="let option of topicWindowOptions" [class.active]="topicWindowDays === option.value" [disabled]="topicsLoading" (click)="setTopicWindow(option.value)">
          {{ option.label }}
        </button>
      </div>
      <div class="summary-toggle operations-tabs" aria-label="Cambiar vista de gestión">
        <button type="button" [class.active]="activeSummaryKind === 'group'" (click)="setSummaryKind('group')">Por área</button>
        <button type="button" [class.active]="activeSummaryKind === 'agent'" (click)="setSummaryKind('agent')">Por responsable</button>
      </div>
    </div>

    <section class="operations-executive-grid">
      <div class="operations-kpi-grid executive">
        <button class="operations-kpi executive" type="button" *ngFor="let item of operationsExecutiveKpis" [ngClass]="item.tone" [class.active]="isOperationsKpiActive(item.key)" [class.risk-breakdown]="item.key === 'risk'" (click)="applyOperationsKpi(item.key)">
          <span class="operations-kpi-icon">{{ item.icon }}</span>
          <div>
            <small>{{ item.label }}</small>
            <strong *ngIf="item.key !== 'risk'">{{ item.value }}</strong>
            <em>{{ item.note }}</em>
            <span class="operations-risk-mini" *ngIf="item.key === 'risk'">
              <i *ngFor="let riskRow of ageRows" [ngClass]="riskRow.color" [class.active]="isRiskActive(riskRow.key)" [title]="riskRow.title + ': ' + formatNumber(riskRow.value)" role="button" tabindex="0" (click)="$event.stopPropagation(); applyPeriodRisk(riskRow.key)" (keydown.enter)="$event.stopPropagation(); applyPeriodRisk(riskRow.key)" (keydown.space)="$event.preventDefault(); $event.stopPropagation(); applyPeriodRisk(riskRow.key)">
                <b>{{ riskRow.range }}</b>
                <small>{{ formatNumber(riskRow.value) }}</small>
              </i>
            </span>
          </div>
          <b *ngIf="item.key !== 'risk'">{{ item.delta }}</b>
        </button>
      </div>
      <article class="operations-nps-card">
        <div class="operations-card-titleline">
          <div>
            <h2>Nota promedio (NPS)</h2>
            <p>{{ satisfactionLoading ? 'Cargando satisfacción...' : satisfactionWindowLabel }}</p>
          </div>
          <span>{{ formatNumber(operationsSatisfactionSummary?.answered || 0) }} respuestas</span>
        </div>
        <div class="operations-nps-body">
          <div class="operations-nps-donut" [ngStyle]="operationsNpsDonutStyle">
            <div>
              <strong>{{ operationsSatisfactionSummary?.nps ?? '—' }}</strong>
              <small>NPS</small>
            </div>
          </div>
          <div class="operations-nps-breakdown">
            <span class="promoters"><i></i>Promotores <b>{{ operationsSatisfactionPct('promoters') }}%</b></span>
            <span class="passives"><i></i>Pasivos <b>{{ operationsSatisfactionPct('passives') }}%</b></span>
            <span class="detractors"><i></i>Detractores <b>{{ operationsSatisfactionPct('detractors') }}%</b></span>
            <em>Nota {{ operationsSatisfactionSummary?.average ?? '—' }} / 10</em>
          </div>
        </div>
      </article>
    </section>

    <section class="operations-chart-grid">
      <article class="operations-panel operations-workload-panel">
        <div class="operations-card-titleline">
          <h2>Estado operativo por {{ activeSummaryKind === 'group' ? 'área' : 'responsable' }}</h2>
          <span>{{ activeSummaryRows.length }} filas · {{ topicWindowLabel }}</span>
        </div>
        <div class="operations-mini-legend">
          <span><i class="load"></i>Recibidos</span>
          <span><i class="open"></i>Sin resolver</span>
          <span><i class="sla"></i>SLA promedio</span>
          <span><i class="critical"></i>Riesgo</span>
        </div>
        <div class="operations-workload-list">
          <article class="operations-workload-row" *ngFor="let row of activeSummaryRows" [class.active]="isSummaryLabelActive(activeSummaryKind, row.label)">
            <div class="operations-workload-main">
              <button class="operations-workload-name" type="button" (click)="applyOperationsScope(row)" [title]="'Filtrar por ' + row.label">{{ row.label }}</button>
              <span>{{ formatNumber(row.total || 0) }} recibidos · {{ formatNumber(row.closed || 0) }} cerrados · {{ formatNumber(row.unresolved || 0) }} sin resolver</span>
            </div>
            <div class="operations-workload-kpis">
              <button type="button" title="Filtrar por recibidos de {{ row.label }}" (click)="applyOperationsScope(row)">
                <small>Recibidos</small>
                <strong>{{ formatNumber(row.total || 0) }}</strong>
              </button>
              <button type="button" title="Filtrar por sin resolver de {{ row.label }}" (click)="applySummaryRowUnresolved(row, activeSummaryKind)">
                <small>Sin resolver</small>
                <strong>{{ formatNumber(row.unresolved || 0) }}</strong>
              </button>
              <button type="button" title="SLA promedio de {{ row.label }}" (click)="applySummaryRowSla(row, activeSummaryKind, 'within')">
                <small>SLA promedio</small>
                <strong>{{ summarySlaRate(row) }}</strong>
              </button>
              <button type="button" title="Filtrar cerrados de {{ row.label }}" (click)="applySummaryRowState(row, activeSummaryKind, 'closed')">
                <small>Cerrados</small>
                <strong>{{ formatNumber(row.closed || 0) }}</strong>
              </button>
              <div class="operations-workload-nps" [ngClass]="satisfactionCategory(operationsRowSatisfaction(row)?.average)" title="Nota promedio y NPS">
                <small>Nota / NPS</small>
                <strong>{{ operationsRowSatisfaction(row)?.average ?? '—' }} / {{ operationsRowSatisfaction(row)?.nps ?? '—' }}</strong>
              </div>
              <div class="operations-workload-balance" title="Balance operativo: participación de pendientes sobre el total sin resolver">
                <small>Balance operativo</small>
                <i class="operations-balance-bar">
                  <b class="unresolved" [style.width.%]="operationsPendingShare(row)"></b>
                </i>
                <strong>{{ formatPercent(operationsPendingShare(row)) }}</strong>
              </div>
            </div>
            <button class="operations-workload-view" type="button" (click)="openOperationsDetail(row)">Detalle</button>
          </article>
        </div>
      </article>

      <div class="remuneration-event-overlay operations-detail-overlay" *ngIf="selectedOperationsDetailRow as detail" (click)="closeOperationsDetail()">
        <article class="remuneration-event-dialog operations-detail-dialog" (click)="$event.stopPropagation()">
          <button type="button" class="remuneration-event-close operations-detail-close" aria-label="Cerrar" (click)="closeOperationsDetail()">×</button>
          <div class="operations-detail-dialog-head">
            <div>
              <span class="schedule-eyebrow">{{ activeSummaryKind === 'group' ? 'Área' : 'Responsable' }}</span>
              <h3>{{ detail.label }}</h3>
            </div>
            <div class="operations-detail-dialog-nps" [ngClass]="satisfactionCategory(operationsRowSatisfaction(detail)?.average)">
              <span>Nota</span>
              <strong>{{ operationsRowSatisfaction(detail)?.average ?? '—' }}</strong>
              <span>NPS</span>
              <strong>{{ operationsRowSatisfaction(detail)?.nps ?? '—' }}</strong>
            </div>
          </div>

          <div class="operations-detail-period-bar">
            <span>Período</span>
            <div>
              <button type="button" *ngFor="let option of operationsDetailPeriodOptions" [class.active]="isOperationsDetailPeriodActive(option.value)" [disabled]="topicsLoading" (click)="setOperationsDetailPeriod(option.value)">
                {{ option.label }}
              </button>
            </div>
          </div>

          <div class="operations-detail-dialog-grid">
            <section class="operations-detail-summary-box">
              <h4>Resumen</h4>
              <div class="operations-detail-dialog-kpis">
                <span><small>Recibidos</small><strong>{{ formatNumber(detail.total || 0) }}</strong></span>
                <span><small>Sin resolver</small><strong>{{ formatNumber(detail.unresolved || 0) }}</strong></span>
                <span><small>Cerrados</small><strong>{{ formatNumber(detail.closed || 0) }}</strong></span>
                <span><small>Riesgosos</small><strong>{{ formatNumber(summaryRiskyTickets(detail)) }}</strong></span>
                <span><small>SLA promedio</small><strong>{{ summarySlaRate(detail) }}</strong></span>
              </div>
            </section>
            <section class="operations-detail-interactions-box">
              <h4>Interacciones</h4>
              <div class="operations-detail-list interactions">
                <button *ngFor="let bucket of interactionBuckets" type="button" (click)="applySummaryRowInteractions(detail, activeSummaryKind, bucket); closeOperationsDetail()">
                  <span>{{ interactionLabel(bucket) }} {{ bucket === '1_interaction' ? 'interacción' : 'interacciones' }}</span>
                  <strong>{{ formatNumber(detail.closed_interactions?.[bucket] || 0) }}</strong>
                </button>
              </div>
            </section>
            <section class="operations-detail-risk-box">
              <h4>Riesgo</h4>
              <div class="operations-detail-risk">
                <span class="risk-critical"><b>Riesgosos</b><em>{{ formatNumber(summaryRiskyTickets(detail)) }}</em></span>
                <span><b>Seguimiento</b><em>{{ formatNumber(detail.risk_medium || 0) }}</em></span>
                <span><b>Bajo</b><em>{{ formatNumber(detail.risk_low || 0) }}</em></span>
              </div>
            </section>
            <section class="operations-detail-top-box operations-detail-top-received">
              <h4>{{ receivedTopicsTitle(detail) }}</h4>
              <div class="operations-detail-list topics" *ngIf="visibleSummaryReceivedTopics(detail).length; else noReceivedTopics">
                <button *ngFor="let topic of visibleSummaryReceivedTopics(detail)" type="button" [class.active]="isTopicActive(topic) && topicScope !== 'resolved' && isSummaryLabelActive(activeSummaryKind, detail.label)" (click)="applySummaryTopic(detail, activeSummaryKind, topic); closeOperationsDetail()">
                  <span>{{ topic.label }}</span>
                  <strong>{{ formatNumber(topic.value) }}</strong>
                </button>
              </div>
              <ng-template #noReceivedTopics><p class="operations-detail-empty">Sin top recibidos para esta selección.</p></ng-template>
            </section>
            <section class="operations-detail-top-box operations-detail-top-resolved">
              <h4>Top 3 resueltos</h4>
              <div class="operations-detail-list topics" *ngIf="visibleSummaryResolvedTopics(detail).length; else noResolvedTopics">
                <button *ngFor="let topic of visibleSummaryResolvedTopics(detail)" type="button" [class.active]="isTopicActive(topic) && topicScope === 'resolved' && isSummaryLabelActive(activeSummaryKind, detail.label)" (click)="applySummaryResolvedTopic(detail, activeSummaryKind, topic); closeOperationsDetail()">
                  <span>{{ topic.label }}</span>
                  <strong>{{ formatNumber(topic.recent || topic.value) }}</strong>
                </button>
              </div>
              <ng-template #noResolvedTopics><p class="operations-detail-empty">Sin top resueltos para esta selección.</p></ng-template>
            </section>
            <section class="operations-detail-trend-box">
              <h4>Tendencia de recibidos, resueltos y pendientes acumulados</h4>
              <div class="trend-legend operations-detail-trend-legend">
                <span><i class="dot red"></i>Recibidos</span>
                <span><i class="dot teal"></i>Resueltos</span>
                <span><i class="dot violet"></i>Pendientes</span>
              </div>
              <div class="trend-line-wrap">
                <svg class="operations-detail-trend-svg" viewBox="0 0 720 180" preserveAspectRatio="none" role="img" aria-label="Tendencia del detalle operativo">
                  <path class="trend-line received" [attr.d]="operationsDetailTrendPath(detail, 'received')"></path>
                  <path class="trend-line closed" [attr.d]="operationsDetailTrendPath(detail, 'closed')"></path>
                  <path class="trend-line backlog" [attr.d]="operationsDetailTrendPath(detail, 'backlog')"></path>
                </svg>
              </div>
              <div class="trend-axis operations-detail-trend-axis">
                <span class="trend-axis-label static" *ngFor="let point of operationsDetailTrendLabels(detail)">
                  <span>{{ trendDateLabel(point) }}</span>
                </span>
              </div>
            </section>
          </div>
        </article>
      </div>

    </section>

    <section class="card segment-card trends-segment" id="segment-tendencias-operations" *ngIf="activeView === 'operations'">
      <div class="card-head segment-head">
        <div>
          <h2>Tendencias</h2>
          <p>Recibidos, resueltos, pendientes acumulados y comparación semanal.</p>
        </div>
        <div class="segment-head-metrics">
          <span>{{ level | titlecase }}</span>
          <strong>{{ weeklyComparisonMetricOptions.length }} métricas</strong>
        </div>
      </div>
      <div class="dashboard-grid trends-grid">
      <article class="card chart-card card-span-6 trend-subcard">
        <div class="card-head">
          <div>
            <h2>Tendencia de recibidos, resueltos y pendientes acumulados</h2>
            <p>Serie diaria con pendientes reales al cierre de cada período.</p>
          </div>
          <div class="trend-head-actions">
            <button class="ghost-button restore-button" *ngIf="fromDate || toDate" type="button" (click)="resetPeriodFilter()">Ver todo el período</button>
            <div class="segmented-control">
              <button class="segmented" [class.active]="level === 'dia'" (click)="setLevel('dia')">Día</button>
              <button class="segmented" [class.active]="level === 'mes'" (click)="setLevel('mes')">Mes</button>
              <button class="segmented" [class.active]="level === 'trimestre'" (click)="setLevel('trimestre')">Trimestre</button>
              <button class="segmented" [class.active]="level === 'semestre'" (click)="setLevel('semestre')">Semestre</button>
              <button class="segmented" [class.active]="level === 'anio'" (click)="setLevel('anio')">Año</button>
            </div>
          </div>
        </div>
        <div class="trend-list trend-chart" *ngIf="trendSeries.length; else noTrendOps">
          <div class="trend-legend">
            <span><i class="dot red"></i>Recibidos</span>
            <span><i class="dot teal"></i>Resueltos</span>
            <span><i class="dot violet"></i>Pendientes</span>
          </div>
          <div class="trend-line-wrap" (mouseleave)="clearTrendHover()">
            <svg class="trend-line-svg" [attr.viewBox]="trendLineViewBox" role="img" aria-label="Tendencia de recibidos, resueltos y pendientes acumulados">
              <line class="trend-grid-line" x1="4" y1="22" x2="716" y2="22"></line>
              <line class="trend-grid-line" x1="4" y1="84" x2="716" y2="84"></line>
              <line class="trend-grid-line" x1="4" y1="147" x2="716" y2="147"></line>
              <line class="trend-grid-line strong" x1="4" y1="210" x2="716" y2="210"></line>
              <path class="trend-area received" [attr.d]="trendAreaPath('received')"></path>
              <path class="trend-area closed" [attr.d]="trendAreaPath('closed')"></path>
              <path class="trend-area backlog" [attr.d]="trendAreaPath('backlog')"></path>
              <path class="trend-line received" [attr.d]="trendLinePath('received')"></path>
              <path class="trend-line closed" [attr.d]="trendLinePath('closed')"></path>
              <path class="trend-line backlog" [attr.d]="trendLinePath('backlog')"></path>
              <line class="trend-hover-line" *ngIf="trendActivePoint" [attr.x1]="trendHoverX" y1="22" [attr.x2]="trendHoverX" y2="210"></line>
              <rect class="trend-hitbox" x="4" y="14" width="712" height="210" (pointerdown)="startTrendPan($event)" (mousemove)="onTrendPointer($event)"></rect>
            </svg>
            <div class="trend-tooltip" *ngIf="trendActivePoint" [class.left-edge]="trendTooltipPositionClass === 'left-edge'" [class.right-edge]="trendTooltipPositionClass === 'right-edge'" [style.left.%]="trendTooltipLeftPct">
              <strong class="trend-tooltip-date">
                <span>{{ trendDateLabel(trendActivePoint) }}</span>
                <small *ngIf="trendDayLabel(trendActivePoint)">| {{ trendDayLabel(trendActivePoint) }}</small>
              </strong>
              <em>Arrastra para recorrer períodos</em>
              <button class="tooltip-metric red" type="button" (pointerdown)="$event.stopPropagation()" (click)="applyTrendMetric(trendActivePoint, 'received')"><i></i>Recibidos <b>{{ formatNumber(trendActivePoint.received) }}</b></button>
              <button class="tooltip-metric teal" type="button" (pointerdown)="$event.stopPropagation()" (click)="applyTrendMetric(trendActivePoint, 'closed')"><i></i>Resueltos <b>{{ formatNumber(trendActivePoint.closed) }}</b></button>
              <button class="tooltip-metric violet" type="button" (pointerdown)="$event.stopPropagation()" (click)="applyTrendMetric(trendActivePoint, 'backlog')"><i></i>Pendientes <b>{{ formatNumber(trendActivePoint.backlog) }}</b></button>
            </div>
            <div class="trend-axis">
              <button class="trend-axis-label" *ngFor="let point of trendAxisLabels" type="button" (click)="applyTrendSelection(point)">
                <span class="axis-date">{{ trendDateLabel(point) }}</span>
                <small class="axis-day" *ngIf="trendDayLabel(point)">| {{ trendDayLabel(point) }}</small>
              </button>
            </div>
          </div>
        </div>
        <ng-template #noTrendOps>
          <div class="empty-state">No hay datos para la tendencia.</div>
        </ng-template>
      </article>

      <article class="card chart-card card-span-6 trend-subcard">
        <div class="card-head">
          <div>
            <h2>Comparativa semanal últimos 3 períodos</h2>
            <p>Tendencia semanal por período según la métrica seleccionada.</p>
          </div>
          <div class="segmented-control weekly-metric-toggle">
            <button
              class="segmented"
              *ngFor="let option of weeklyComparisonMetricOptions"
              [class.active]="weeklyComparisonMetric === option.key"
              (click)="weeklyComparisonMetric = option.key; clearWeeklyComparisonHover()"
            >
              {{ option.label }}
            </button>
          </div>
        </div>
        <div class="trend-list trend-chart weekly-comparison-chart" *ngIf="weeklyComparisonSeries.length; else noWeeklyComparisonOps">
          <div class="trend-legend">
            <span *ngFor="let serie of weeklyComparisonSeries; let i = index">
              <i class="dot" [class.period-a]="i === 0" [class.period-b]="i === 1" [class.period-c]="i === 2"></i>
              {{ displayValue('trend', serie.label) }}
            </span>
          </div>
          <div class="trend-line-wrap">
            <svg class="trend-line-svg" [attr.viewBox]="trendLineViewBox" role="img" aria-label="Comparativa semanal de los últimos 3 períodos">
              <line class="trend-grid-line" x1="4" y1="22" x2="716" y2="22"></line>
              <line class="trend-grid-line" x1="4" y1="84" x2="716" y2="84"></line>
              <line class="trend-grid-line" x1="4" y1="147" x2="716" y2="147"></line>
              <line class="trend-grid-line strong" x1="4" y1="210" x2="716" y2="210"></line>
              <ng-container *ngFor="let serie of weeklyComparisonSeries; let i = index">
                <path class="trend-area period-a" *ngIf="i === 0" [attr.d]="weeklyComparisonAreaPath(serie)"></path>
                <path class="trend-area period-b" *ngIf="i === 1" [attr.d]="weeklyComparisonAreaPath(serie)"></path>
                <path class="trend-area period-c" *ngIf="i === 2" [attr.d]="weeklyComparisonAreaPath(serie)"></path>
                <path class="trend-line period-a" *ngIf="i === 0" [attr.d]="weeklyComparisonPath(serie)"></path>
                <path class="trend-line period-b" *ngIf="i === 1" [attr.d]="weeklyComparisonPath(serie)"></path>
                <path class="trend-line period-c" *ngIf="i === 2" [attr.d]="weeklyComparisonPath(serie)"></path>
              </ng-container>
              <line class="trend-hover-line" *ngIf="weeklyComparisonActiveAxis" [attr.x1]="weeklyComparisonHoverX" y1="22" [attr.x2]="weeklyComparisonHoverX" y2="210"></line>
              <rect class="trend-hitbox compare-hitbox" x="4" y="14" width="712" height="210" (mousemove)="onWeeklyComparisonPointer($event)" (mouseleave)="clearWeeklyComparisonHover()"></rect>
            </svg>
            <div class="trend-tooltip compare-tooltip" *ngIf="weeklyComparisonActiveAxis" [class.left-edge]="weeklyComparisonTooltipPositionClass === 'left-edge'" [class.right-edge]="weeklyComparisonTooltipPositionClass === 'right-edge'" [style.left.%]="weeklyComparisonTooltipLeftPct">
              <strong>{{ weeklyComparisonActiveAxis.label }}</strong>
              <em>Comparativa por período</em>
              <span class="tooltip-metric" *ngFor="let row of weeklyComparisonTooltipRows" [class.red]="row.color === 'red'" [class.teal]="row.color === 'teal'" [class.violet]="row.color === 'violet'">
                <i></i>{{ displayValue('trend', row.label) }} <b>{{ formatNumber(row.value) }}</b>
              </span>
            </div>
            <div class="trend-axis">
              <span class="trend-axis-label static" *ngFor="let item of weeklyComparisonAxis">
                <span>{{ item.label }}</span>
              </span>
            </div>
          </div>
        </div>
        <ng-template #noWeeklyComparisonOps>
          <div class="empty-state">No hay datos para comparar períodos.</div>
        </ng-template>
      </article>
      </div>
    </section>

    <section class="operations-table-card" *ngIf="false">
      <div class="operations-table-head">
        <div>
          <h2>{{ activeSummaryKind === 'group' ? 'Ranking por área' : 'Ranking por responsable' }}</h2>
          <p>{{ activeSummaryRows.length }} filas · Tickets: {{ topicWindowLabel }} · Nota/NPS: {{ satisfactionWindowLabel }}</p>
        </div>
        <div class="operations-sort operations-nps-window" aria-label="Ventana Nota NPS">
          <span>Nota/NPS</span>
          <button type="button" *ngFor="let option of satisfactionWindowOptions" [class.active]="selectedSatisfactionWindow === option.value" (click)="setSatisfactionWindow(option.value)">
            {{ option.label }}
          </button>
        </div>
        <div class="operations-sort" aria-label="Ordenar ranking">
          <span>Ordenar</span>
          <button type="button" [class.active]="operationsSort === 'load'" (click)="setOperationsSort('load')">Mayor carga</button>
          <button type="button" [class.active]="operationsSort === 'unresolved'" (click)="setOperationsSort('unresolved')">Más sin resolver</button>
          <button type="button" [class.active]="operationsSort === 'sla'" (click)="setOperationsSort('sla')">Peor SLA</button>
          <button type="button" [class.active]="operationsSort === 'closed'" (click)="setOperationsSort('closed')">Más cerrados</button>
        </div>
      </div>
      <div class="operations-table">
        <div class="operations-table-row head">
          <span>{{ activeSummaryKind === 'group' ? 'Área' : 'Responsable' }}</span>
          <span>Recibidos</span>
          <span>Sin resolver</span>
          <span>SLA promedio</span>
          <span>Cerrados</span>
          <span>Nota / NPS</span>
          <span>Balance operativo</span>
          <span>Ver detalle</span>
        </div>
        <article class="operations-table-item" *ngFor="let row of activeSummaryRows" [class.active]="isSummaryLabelActive(activeSummaryKind, row.label)" (click)="applyOperationsScope(row)">
          <div class="operations-table-row">
            <span class="entity"><b>{{ activeSummaryRows.indexOf(row) + 1 }}</b><strong>{{ row.label }}</strong></span>
            <span>{{ formatNumber(row.total) }}</span>
            <span class="warn">{{ formatNumber(row.unresolved) }}</span>
            <span>{{ summarySlaRate(row) }}</span>
            <span>{{ formatNumber(row.closed || 0) }}</span>
            <span class="operations-nps-cell" [ngClass]="satisfactionCategory(operationsRowSatisfaction(row)?.average)">
              <span>
                <i></i>
                <small>Nota</small>
                <strong>{{ operationsRowSatisfaction(row)?.average ?? '—' }}</strong>
              </span>
              <em>|</em>
              <span>
                <i></i>
                <small>NPS</small>
                <strong>{{ operationsRowSatisfaction(row)?.nps ?? '—' }}</strong>
              </span>
            </span>
            <span class="operations-balance-cell">
              <i class="operations-balance-bar">
                <b class="closed" [style.width.%]="row.total ? (row.closed / row.total) * 100 : 0"></b>
                <b class="unresolved" [style.width.%]="row.total ? (row.unresolved / row.total) * 100 : 0"></b>
              </i>
              <small>{{ formatPercent(row.total ? (row.closed / row.total) * 100 : 0) }} cerrado</small>
            </span>
            <span><button class="operations-detail-toggle" type="button" (click)="$event.stopPropagation(); toggleSummaryDetails(row)">{{ isSummaryDetailsOpen(row) ? 'Ocultar' : 'Ver detalle' }}</button></span>
          </div>
          <div class="operations-detail" *ngIf="isSummaryDetailsOpen(row)" (click)="$event.stopPropagation()">
            <div class="summary-interactions">
              <span>Cierres por interacción</span>
              <button *ngFor="let bucket of interactionBuckets" type="button" (click)="applySummaryRowInteractions(row, activeSummaryKind, bucket)">
                <b>{{ interactionLabel(bucket) }}</b>
                <em>{{ formatNumber(row.closed_interactions?.[bucket] || 0) }}</em>
              </button>
            </div>
            <div class="summary-top-resolved" *ngIf="summaryResolvedTopics(row).length">
              <span>Top cerrados</span>
              <button *ngFor="let topic of visibleSummaryResolvedTopics(row)" type="button" [class.active]="isTopicActive(topic) && topicScope === 'resolved' && isSummaryLabelActive(activeSummaryKind, row.label)" (click)="applySummaryResolvedTopic(row, activeSummaryKind, topic)">
                <b>{{ topic.label }}</b>
                <em>{{ formatNumber(topic.recent) }}</em>
              </button>
              <button class="summary-more-chip" type="button" *ngIf="hiddenSummaryResolvedTopicsCount(row)" (click)="applySummaryResolved(row, activeSummaryKind)">+{{ hiddenSummaryResolvedTopicsCount(row) }} más</button>
            </div>
          </div>
        </article>
            <div class="empty-state" *ngIf="!activeSummaryRows.length">{{ activeSummaryEmptyText }}</div>
        </div>
    </section>

    <section class="card table-card segment-card" id="segment-tickets-operations" *ngIf="activeView === 'operations'">
      <div class="card-head table-head segment-head">
        <div>
          <h2>Tickets filtrados</h2>
          <div class="ticket-meta">
            <span class="ticket-pill total">{{ tickets.total || 0 }} tickets</span>
            <span class="ticket-pill page">Página {{ page + 1 }} de {{ totalPages }}</span>
          </div>
        </div>
        <div class="segment-head-metrics tickets-head-metrics">
          <span>Página {{ page + 1 }} / {{ totalPages }}</span>
          <strong>{{ formatNumber(tickets.total || 0) }} tickets</strong>
        </div>
        <div class="table-actions">
          <div class="interaction-strip" aria-label="Interacciones ticket resueltos">
            <span class="interaction-strip-title">Interacciones ticket resueltos</span>
            <button class="interaction-pill" *ngFor="let item of interactionSummary" type="button" [class.active]="isSummaryInteractionActive(item.key)" (click)="applySummaryInteractions(item.key)">
              <b>{{ item.label }}</b>
              <span>{{ formatNumber(item.value) }}</span>
            </button>
          </div>
          <div class="ticket-risk-actions" aria-label="Riesgo sin resolver">
            <button class="ticket-risk-pill medium" type="button" [class.active]="isUnresolvedRiskActive('medium')" (click)="applyTicketRisk('medium')">Riesgo medio</button>
            <button class="ticket-risk-pill high" type="button" [class.active]="isUnresolvedRiskActive('high')" (click)="applyTicketRisk('high')">Riesgo alto</button>
          </div>
          <button class="export-button" type="button" (click)="exportCsv()">Exportar CSV</button>
        </div>
      </div>

      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th><button class="sort-head" type="button" (click)="sortTickets('id')">ID <span>{{ sortIcon('id') }}</span></button></th>
              <th><button class="sort-head" type="button" (click)="sortTickets('estado')">Estado <span>{{ sortIcon('estado') }}</span></button></th>
              <th><button class="sort-head" type="button" (click)="sortTickets('prioridad')">Prioridad <span>{{ sortIcon('prioridad') }}</span></button></th>
              <th><button class="sort-head" type="button" (click)="sortTickets('tipo')">Tipo <span>{{ sortIcon('tipo') }}</span></button></th>
              <th><button class="sort-head" type="button" (click)="sortTickets('agente')">Agente <span>{{ sortIcon('agente') }}</span></button></th>
              <th><button class="sort-head" type="button" (click)="sortTickets('grupo')">Grupo <span>{{ sortIcon('grupo') }}</span></button></th>
              <th><button class="sort-head" type="button" (click)="sortTickets('interacciones')">Interacciones <span>{{ sortIcon('interacciones') }}</span></button></th>
              <th><button class="sort-head" type="button" (click)="sortTickets('sin_interaccion')">Dias sin interaccion <span>{{ sortIcon('sin_interaccion') }}</span></button></th>
              <th><button class="sort-head" type="button" (click)="sortTickets('creado')">Dias creado <span>{{ sortIcon('creado') }}</span></button></th>
              <th><button class="sort-head" type="button" (click)="sortTickets('sla')">SLA 1ra resp. <span>{{ sortIcon('sla') }}</span></button></th>
              <th><button class="sort-head" type="button" (click)="sortTickets('asunto')">Asunto <span>{{ sortIcon('asunto') }}</span></button></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ticket of ticketsPage; trackBy: trackByTicket">
              <td>
                <a class="ticket-id-link" [href]="freshdeskTicketUrl(ticket['ID del ticket'])" target="_blank" rel="noopener noreferrer">{{ ticket['ID del ticket'] }}</a>
              </td>
              <td><span class="status-chip">{{ ticketValue('estado', ticket.Estado) }}</span></td>
              <td>{{ ticketValue('prioridad', ticket.Prioridad) }}</td>
              <td>{{ ticketValue('tipo', ticket.Tipo) }}</td>
              <td>{{ ticket.Agente }}</td>
              <td>{{ ticket.Grupo }}</td>
              <td><span class="interaction-chip">{{ formatNumber(ticket.Interacciones || 0) }}</span></td>
              <td>
                <span class="risk-chip" [ngClass]="riskClass(ticket)">{{ staleDaysLabel(ticket) }}</span>
              </td>
              <td>
                <span class="created-chip" [ngClass]="createdAgeClass(ticket)">
                  {{ createdAgeLabel(ticket) }}
                </span>
              </td>
              <td><span class="sla-chip" [ngClass]="slaClass(ticket)">{{ ticketValue('sla', ticket['Estado de la primera respuesta']) }}</span></td>
              <td>{{ ticket.Asunto }}</td>
            </tr>
            <tr *ngIf="!ticketsPage.length">
              <td colspan="11" class="empty-state">No hay tickets para el filtro actual.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="tickets-pager">
        <button class="ghost-button" type="button" [disabled]="page === 0" (click)="goToPage(0)">Primera</button>
        <button class="ghost-button" type="button" [disabled]="page === 0" (click)="prevPage()">Anterior</button>
        <div class="satisfaction-page-numbers tickets-page-numbers">
          <button type="button" *ngFor="let pageNumber of ticketPageNumbers" [class.active]="page === pageNumber" [disabled]="totalPages <= 1" (click)="goToPage(pageNumber)">
            {{ pageNumber + 1 }}
          </button>
        </div>
        <button class="ghost-button" type="button" [disabled]="page >= totalPages - 1" (click)="nextPage()">Siguiente</button>
        <button class="ghost-button" type="button" [disabled]="page >= totalPages - 1" (click)="goToPage(totalPages - 1)">Última</button>
      </div>
    </section>
  </section>

  <section class="card table-card segment-card" id="segment-tickets" *ngIf="activeView === 'dashboard'">
    <div class="card-head table-head segment-head">
      <div>
        <h2>Tickets filtrados</h2>
        <div class="ticket-meta">
          <span class="ticket-pill total">{{ tickets.total || 0 }} tickets</span>
          <span class="ticket-pill page">Página {{ page + 1 }} de {{ totalPages }}</span>
        </div>
      </div>
      <div class="segment-head-metrics tickets-head-metrics">
        <span>Página {{ page + 1 }} / {{ totalPages }}</span>
        <strong>{{ formatNumber(tickets.total || 0) }} tickets</strong>
      </div>
      <div class="table-actions">
        <div class="interaction-strip" aria-label="Interacciones ticket resueltos">
          <span class="interaction-strip-title">Interacciones ticket resueltos</span>
          <button class="interaction-pill" *ngFor="let item of interactionSummary" type="button" [class.active]="isSummaryInteractionActive(item.key)" (click)="applySummaryInteractions(item.key)">
            <b>{{ item.label }}</b>
            <span>{{ formatNumber(item.value) }}</span>
          </button>
        </div>
        <div class="ticket-risk-actions" aria-label="Riesgo sin resolver">
          <button class="ticket-risk-pill medium" type="button" [class.active]="isUnresolvedRiskActive('medium')" (click)="applyTicketRisk('medium')">Riesgo medio</button>
          <button class="ticket-risk-pill high" type="button" [class.active]="isUnresolvedRiskActive('high')" (click)="applyTicketRisk('high')">Riesgo alto</button>
        </div>
        <button class="export-button" type="button" (click)="exportCsv()">Exportar CSV</button>
      </div>
    </div>

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th><button class="sort-head" type="button" (click)="sortTickets('id')">ID <span>{{ sortIcon('id') }}</span></button></th>
            <th><button class="sort-head" type="button" (click)="sortTickets('estado')">Estado <span>{{ sortIcon('estado') }}</span></button></th>
            <th><button class="sort-head" type="button" (click)="sortTickets('prioridad')">Prioridad <span>{{ sortIcon('prioridad') }}</span></button></th>
            <th><button class="sort-head" type="button" (click)="sortTickets('tipo')">Tipo <span>{{ sortIcon('tipo') }}</span></button></th>
            <th><button class="sort-head" type="button" (click)="sortTickets('agente')">Agente <span>{{ sortIcon('agente') }}</span></button></th>
            <th><button class="sort-head" type="button" (click)="sortTickets('grupo')">Grupo <span>{{ sortIcon('grupo') }}</span></button></th>
            <th><button class="sort-head" type="button" (click)="sortTickets('interacciones')">Interacciones <span>{{ sortIcon('interacciones') }}</span></button></th>
            <th><button class="sort-head" type="button" (click)="sortTickets('sin_interaccion')">Dias sin interaccion <span>{{ sortIcon('sin_interaccion') }}</span></button></th>
            <th><button class="sort-head" type="button" (click)="sortTickets('creado')">Dias creado <span>{{ sortIcon('creado') }}</span></button></th>
            <th><button class="sort-head" type="button" (click)="sortTickets('sla')">SLA 1ra resp. <span>{{ sortIcon('sla') }}</span></button></th>
            <th><button class="sort-head" type="button" (click)="sortTickets('asunto')">Asunto <span>{{ sortIcon('asunto') }}</span></button></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ticket of ticketsPage; trackBy: trackByTicket">
            <td>
              <a class="ticket-id-link" [href]="freshdeskTicketUrl(ticket['ID del ticket'])" target="_blank" rel="noopener noreferrer">{{ ticket['ID del ticket'] }}</a>
            </td>
            <td><span class="status-chip">{{ ticketValue('estado', ticket.Estado) }}</span></td>
            <td>{{ ticketValue('prioridad', ticket.Prioridad) }}</td>
            <td>{{ ticketValue('tipo', ticket.Tipo) }}</td>
            <td>{{ ticket.Agente }}</td>
            <td>{{ ticket.Grupo }}</td>
            <td><span class="interaction-chip">{{ formatNumber(ticket.Interacciones || 0) }}</span></td>
            <td>
              <span class="risk-chip" [ngClass]="riskClass(ticket)">{{ staleDaysLabel(ticket) }}</span>
            </td>
            <td>
              <span class="created-chip" [ngClass]="createdAgeClass(ticket)">
                {{ createdAgeLabel(ticket) }}
              </span>
            </td>
            <td><span class="sla-chip" [ngClass]="slaClass(ticket)">{{ ticketValue('sla', ticket['Estado de la primera respuesta']) }}</span></td>
            <td>{{ ticket.Asunto }}</td>
          </tr>
          <tr *ngIf="!ticketsPage.length">
            <td colspan="11" class="empty-state">No hay tickets para el filtro actual.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="tickets-pager">
      <button class="ghost-button" type="button" [disabled]="page === 0" (click)="goToPage(0)">Primera</button>
      <button class="ghost-button" type="button" [disabled]="page === 0" (click)="prevPage()">Anterior</button>
      <div class="satisfaction-page-numbers tickets-page-numbers">
        <button type="button" *ngFor="let pageNumber of ticketPageNumbers" [class.active]="page === pageNumber" [disabled]="totalPages <= 1" (click)="goToPage(pageNumber)">
          {{ pageNumber + 1 }}
        </button>
      </div>
      <button class="ghost-button" type="button" [disabled]="page >= totalPages - 1" (click)="nextPage()">Siguiente</button>
      <button class="ghost-button" type="button" [disabled]="page >= totalPages - 1" (click)="goToPage(totalPages - 1)">Última</button>
    </div>
  </section>
  </ng-container>

  <ng-container *ngIf="activeView === 'schedule'">
    <section class="schedule-page segment-card">
      <div class="schedule-hero card">
        <div>
          <span class="schedule-eyebrow">Plan anual HR</span>
          <h1>Cronograma de actividades</h1>
          <p>Vista mensual de hitos por proceso, actualizada desde el archivo Excel del cronograma.</p>
        </div>
        <div class="schedule-hero-metrics">
          <button type="button" class="schedule-metric-card activities" [class.active]="!selectedScheduleStatus" (click)="focusScheduleActivities()">
            <small>Actividades</small>
            <strong>{{ formatNumber(scheduleVisibleActivitiesCount) }}</strong>
          </button>
          <button type="button" class="schedule-metric-card summary" [class.active]="!selectedScheduleStatus" (click)="focusScheduleMilestones()">
            <small>Hitos</small>
            <strong>{{ formatNumber(scheduleVisibleMilestonesCount) }}</strong>
          </button>
          <button type="button" class="schedule-metric-card done" [class.active]="selectedScheduleStatus === 'done'" (click)="toggleScheduleStatus('done')">
            <small>Completados</small>
            <strong>{{ formatNumber(scheduleVisibleDoneCount) }}</strong>
          </button>
          <button type="button" class="schedule-metric-card pending" [class.active]="selectedScheduleStatus === 'pending'" (click)="toggleScheduleStatus('pending')">
            <small>Pendientes</small>
            <strong>{{ formatNumber(scheduleVisiblePendingCount) }}</strong>
          </button>
        </div>
      </div>

      <div class="empty-state schedule-error" *ngIf="scheduleError">{{ scheduleError }}</div>

      <div class="schedule-subnav-row">
        <div class="schedule-subnav" role="tablist" aria-label="Vista de cronograma">
          <button type="button" role="tab" [class.active]="scheduleSubView === 'overview'" (click)="setScheduleSubView('overview')">Vista general</button>
          <button type="button" role="tab" [class.active]="scheduleSubView === 'calendar'" (click)="setScheduleSubView('calendar')">Calendario operación personas</button>
          <button type="button" role="tab" [class.active]="scheduleSubView === 'planning'" (click)="setScheduleSubView('planning')">Planificación equipo</button>
        </div>
        <button type="button" class="schedule-export-button" data-export-exclude="true" [disabled]="schedulePngExporting || scheduleLoading || !schedule" (click)="exportCurrentScheduleViewPng()">
          {{ schedulePngExporting ? 'Generando PNG' : 'Exportar PNG' }}
        </button>
      </div>

      <ng-container *ngIf="scheduleSubView === 'overview'">
        <div id="schedule-overview-export" class="schedule-export-surface">
        <section class="schedule-month-grid" *ngIf="schedule?.months?.length">
          <button class="schedule-month-card" type="button" *ngFor="let month of filteredScheduleMonths" [class.has-items]="month.total" [class.active]="selectedScheduleMonth === month.key" (click)="toggleScheduleMonth(month.key)">
            <div class="schedule-month-head">
              <span>{{ month.label }}</span>
              <strong>{{ month.total || 0 }}</strong>
            </div>
            <div class="schedule-month-bars">
              <i class="done" [style.width.%]="month.total ? (month.done / month.total) * 100 : 0"></i>
              <i class="pending" [style.left.%]="month.total ? (month.done / month.total) * 100 : 0" [style.width.%]="month.total ? (month.pending / month.total) * 100 : 0"></i>
            </div>
            <div class="schedule-month-foot">
              <span>{{ month.done || 0 }} ejecutados</span>
              <span>{{ month.pending || 0 }} pendientes</span>
            </div>
          </button>
        </section>

        <section class="schedule-layout" *ngIf="schedule">
          <article class="card schedule-process-panel">
            <div class="card-head segment-head">
              <div>
                <h2>Procesos</h2>
                <p>Avance por familia de actividad.</p>
              </div>
            </div>
            <div class="schedule-process-list">
              <button class="schedule-process" type="button" *ngFor="let item of filteredScheduleProcesses" [class.active]="selectedScheduleProcess === item.process" (click)="openScheduleRoadmapProcess(item.process)">
                <div>
                  <strong>{{ item.process }}</strong>
                  <span>{{ item.activities }} actividades · {{ item.milestones }} hitos</span>
                </div>
                <div class="schedule-process-actions">
                  <b>{{ processCompletion(item) }}%</b>
                </div>
                <i><em [style.width.%]="processCompletion(item)"></em></i>
              </button>
            </div>
          </article>

          <article class="card schedule-next-panel">
            <div class="card-head segment-head">
              <div>
                <h2>{{ scheduleHighlightsTitle }}</h2>
                <p>{{ scheduleHighlightsSubtitle }}</p>
              </div>
            </div>
            <div class="schedule-next-list">
              <button class="schedule-next" type="button" *ngFor="let item of visibleScheduleNextMilestones" (click)="openScheduleRoadmapProcess(item.process)">
                <span>{{ item.month }}</span>
                <strong>{{ item.activity }}</strong>
                <small>{{ item.process }}</small>
              </button>
              <button class="schedule-next-more" type="button" *ngIf="hiddenScheduleNextMilestonesCount" (click)="clearScheduleFilters()">+{{ hiddenScheduleNextMilestonesCount }} hitos · Ver más</button>
              <div class="empty-state" *ngIf="!filteredScheduleNextMilestones.length">{{ scheduleHighlightsEmptyText }}</div>
            </div>
          </article>

          <article class="card schedule-critical-panel">
            <div class="card-head segment-head">
              <div>
                <h2>Meses críticos</h2>
                <p>Concentración de hitos pendientes.</p>
              </div>
            </div>
            <div class="schedule-planning-month-list">
              <button class="schedule-planning-month" type="button" *ngFor="let month of schedulePlanningCriticalMonths" [class.active]="selectedScheduleMonth === month.key" (click)="toggleScheduleMonth(month.key)">
                <div>
                  <strong>{{ month.label }}</strong>
                  <span>{{ month.total }} hitos · {{ month.completion }}% avance</span>
                </div>
                <b>{{ month.pending }}</b>
                <i><em [style.width.%]="month.intensity"></em></i>
              </button>
              <div class="empty-state" *ngIf="!schedulePlanningCriticalMonths.length">Sin meses con carga para la selección actual.</div>
            </div>
          </article>
        </section>

        <section class="card schedule-timeline-card" *ngIf="schedule">
          <div class="card-head segment-head">
            <div>
              <h2>Línea anual de actividades</h2>
              <p>Distribución de cada hito por mes.</p>
            </div>
            <div class="schedule-roadmap-summary">
              <span>{{ formatNumber(scheduleRoadmapSummary.activities) }} actividades</span>
              <span>{{ formatNumber(scheduleRoadmapSummary.milestones) }} hitos</span>
              <strong>{{ formatNumber(scheduleRoadmapSummary.done) }} completados</strong>
              <strong>{{ formatNumber(scheduleRoadmapSummary.pending) }} pendientes</strong>
            </div>
          </div>
          <div class="schedule-roadmap">
            <div class="schedule-roadmap-months">
              <strong>Área</strong>
              <div class="schedule-roadmap-axis">
                <button type="button" *ngFor="let month of schedule.months" [class.active]="selectedScheduleRoadmapMonth === month.key" (click)="selectScheduleRoadmapMonth(month.key)">{{ month.label.slice(0, 3) }}</button>
              </div>
            </div>
            <article class="schedule-roadmap-row" *ngFor="let group of scheduleRoadmapGroups">
              <div class="schedule-roadmap-info">
                <button class="schedule-roadmap-area" type="button" [class.active]="selectedScheduleRoadmapProcess === group.process" (click)="openScheduleRoadmapGroup(group)">{{ group.process }}</button>
                <span>{{ group.activities }} actividades · {{ group.milestones }} hitos</span>
                <b>{{ group.completion }}%</b>
              </div>
              <div class="schedule-roadmap-track">
                <i></i>
                <button class="schedule-roadmap-point" type="button" *ngFor="let point of group.points" [ngClass]="scheduleStatusClass(point.status_key)" [class.active]="isSchedulePointActive(point)" [class.grouped]="point.count > 1" [style.left.%]="point.position" [attr.title]="point.detail || (point.activity + ' · ' + point.status)" (click)="selectScheduleRoadmapPoint(point)">
                  <b *ngIf="point.count > 1">{{ point.count }}</b>
                  <span class="schedule-roadmap-tooltip">
                    <strong>{{ point.count > 1 ? (point.count + ' hitos') : point.activity }}</strong>
                    <small>{{ point.month }}</small>
                    <em *ngFor="let detail of point.items || [point]">{{ detail.activity }} - {{ detail.status }}</em>
                  </span>
                </button>
              </div>
            </article>
            <div class="empty-state schedule-empty-row" *ngIf="!scheduleRoadmapGroups.length">Sin actividades para la selección actual.</div>
          </div>
        </section>

        </div>

        <div class="remuneration-event-overlay schedule-roadmap-overlay" data-export-exclude="true" *ngIf="selectedScheduleRoadmapGroup || selectedScheduleRoadmapMonth" (click)="closeScheduleRoadmapGroup()">
          <article class="remuneration-event-dialog schedule-roadmap-dialog" (click)="$event.stopPropagation()">
            <button type="button" class="remuneration-event-close schedule-roadmap-dialog-close" aria-label="Cerrar" (click)="closeScheduleRoadmapGroup()">×</button>
            <ng-container *ngIf="selectedScheduleRoadmapMonth; else pointOrGroupView">
              <div class="schedule-roadmap-dialog-head">
                <div>
                  <span class="schedule-eyebrow">Línea anual</span>
                  <h3>{{ selectedScheduleRoadmapMonthLabel }}</h3>
                </div>
                <div class="schedule-roadmap-dialog-kpis">
                  <span>{{ selectedScheduleMonthActivities.length }} actividades</span>
                </div>
              </div>
              <div class="schedule-roadmap-dialog-list">
                <article *ngFor="let activity of selectedScheduleMonthActivities">
                  <div>
                    <small class="schedule-roadmap-dialog-process">{{ activity.process }}</small>
                    <strong>{{ activity.activity }}</strong>
                    <span>{{ activity.milestones.length }} hitos · {{ activity.done }} completados · {{ activity.pending }} pendientes</span>
                    <div class="schedule-roadmap-dialog-hitos">
                      <small *ngFor="let milestone of activity.milestones" [ngClass]="scheduleStatusClass(milestone.status_key)">
                        {{ milestone.monthLabel }} · {{ milestone.status }}
                      </small>
                    </div>
                  </div>
                  <div class="schedule-roadmap-dialog-months">
                    <em *ngFor="let milestone of activity.milestones" [ngClass]="scheduleStatusClass(milestone.status_key)">
                      {{ milestone.monthLabel }}
                    </em>
                  </div>
                </article>
              </div>
            </ng-container>
            <ng-template #pointOrGroupView>
              <ng-container *ngIf="selectedScheduleRoadmapPoint; else fullGroupView">
                <div class="schedule-roadmap-dialog-head">
                  <div>
                    <span class="schedule-eyebrow">Línea anual</span>
                    <h3>{{ selectedScheduleRoadmapGroup.process }}</h3>
                  </div>
                  <div class="schedule-roadmap-dialog-kpis">
                    <span>{{ scheduleMonthFullLabel(selectedScheduleRoadmapPoint.month) }}</span>
                    <span>{{ selectedScheduleRoadmapPoint.count > 1 ? selectedScheduleRoadmapPoint.count + ' hitos' : '1 hito' }}</span>
                  </div>
                </div>
                <div class="schedule-roadmap-dialog-list">
                  <article *ngFor="let item of selectedScheduleRoadmapPoint.items">
                    <div>
                      <strong>{{ item.activity }}</strong>
                      <span>{{ item.status }}</span>
                      <div class="schedule-roadmap-dialog-hitos">
                        <small [ngClass]="scheduleStatusClass(item.status_key)">
                          {{ scheduleMonthShortLabel(item.month) }} · {{ item.status }}
                        </small>
                      </div>
                    </div>
                    <div class="schedule-roadmap-dialog-months">
                      <em [ngClass]="scheduleStatusClass(item.status_key)">{{ scheduleMonthShortLabel(item.month) }}</em>
                    </div>
                  </article>
                </div>
              </ng-container>
            </ng-template>
            <ng-template #fullGroupView>
              <div class="schedule-roadmap-dialog-head">
                <div>
                  <span class="schedule-eyebrow">Línea anual</span>
                  <h3>{{ selectedScheduleRoadmapGroup.process }}</h3>
                </div>
                <div class="schedule-roadmap-dialog-kpis">
                  <span>{{ selectedScheduleRoadmapGroup.activities }} actividades</span>
                  <span>{{ selectedScheduleRoadmapGroup.milestones }} hitos</span>
                  <strong>{{ selectedScheduleRoadmapGroup.completion }}%</strong>
                </div>
              </div>
              <div class="schedule-roadmap-dialog-timeline schedule-roadmap">
                <div class="schedule-roadmap-months">
                  <strong>Área</strong>
                  <div class="schedule-roadmap-axis">
                    <button type="button" *ngFor="let month of schedule.months" disabled>{{ month.label.slice(0, 3) }}</button>
                  </div>
                </div>
                <article class="schedule-roadmap-row schedule-roadmap-dialog-row">
                  <div class="schedule-roadmap-info">
                    <strong>{{ selectedScheduleRoadmapGroup.process }}</strong>
                    <span>{{ selectedScheduleRoadmapGroup.activities }} actividades · {{ selectedScheduleRoadmapGroup.milestones }} hitos</span>
                    <b>{{ selectedScheduleRoadmapGroup.completion }}%</b>
                  </div>
                  <div class="schedule-roadmap-track">
                    <i></i>
                    <button class="schedule-roadmap-point" type="button" *ngFor="let point of selectedScheduleRoadmapGroup.points" [ngClass]="scheduleStatusClass(point.status_key)" [class.grouped]="point.count > 1" [style.left.%]="point.position" [attr.title]="point.detail || (point.activity + ' · ' + point.status)">
                      <b *ngIf="point.count > 1">{{ point.count }}</b>
                    </button>
                  </div>
                </article>
              </div>
              <div class="schedule-roadmap-dialog-list">
                <article *ngFor="let activity of selectedScheduleRoadmapActivities">
                  <div>
                    <strong>{{ activity.activity }}</strong>
                    <span>{{ activity.milestones.length }} hitos · {{ activity.done }} completados · {{ activity.pending }} pendientes</span>
                    <div class="schedule-roadmap-dialog-hitos">
                      <small *ngFor="let milestone of activity.milestones" [ngClass]="scheduleStatusClass(milestone.status_key)">
                        {{ milestone.monthLabel }} · {{ milestone.status }}
                      </small>
                    </div>
                  </div>
                  <div class="schedule-roadmap-dialog-months">
                    <em *ngFor="let milestone of activity.milestones" [ngClass]="scheduleStatusClass(milestone.status_key)">
                      {{ milestone.monthLabel }}
                    </em>
                  </div>
                </article>
              </div>
            </ng-template>
          </article>
        </div>
      </ng-container>

      <ng-container *ngIf="scheduleSubView === 'calendar'">
        <div id="schedule-calendar-export" class="schedule-export-surface">
        <section class="card remuneration-calendar-hint schedule-calendar-hint" *ngIf="!scheduleRemunerationCalendar && schedule">
          <div>
            <span class="schedule-eyebrow">Sin calendario disponible</span>
            <h2>No se encontró archivo de calendario de remuneraciones</h2>
            <p>El calendario mensual de remuneraciones estará disponible cuando se integre el archivo Excel correspondiente.</p>
          </div>
        </section>

        <section class="schedule-calendar-toolbar" *ngIf="scheduleRemunerationCalendar">
          <div class="schedule-calendar-toolbar-info">
            <span class="schedule-eyebrow">Calendario detallado</span>
            <h2>{{ scheduleRemunerationCalendar.process || 'Operación personas' }} · {{ scheduleRemunerationCalendarMonthLabel }}</h2>
            <p>{{ scheduleRemunerationCalendarMonthFilteredEventCount }} hitos operativos desde {{ scheduleRemunerationCalendar.file_name }}.</p>
          </div>
          <div class="schedule-calendar-month-selector" *ngIf="scheduleRemunerationCalendarMonthOptions.length > 1">
            <button type="button" class="schedule-calendar-month-nav" [disabled]="!canGoPreviousScheduleRemunerationMonth" (click)="navigateScheduleRemunerationMonth(-1)">Anterior</button>
            <label>
              <span>Mes</span>
              <select [ngModel]="selectedScheduleRemunerationMonth?.key" (ngModelChange)="selectScheduleRemunerationMonth($event)">
                <option *ngFor="let month of scheduleRemunerationCalendarMonthOptions" [ngValue]="month.key">
                  {{ month.label }} · {{ month.total }} hito{{ month.total === 1 ? '' : 's' }}
                </option>
              </select>
            </label>
            <button type="button" class="schedule-calendar-month-nav" [disabled]="!canGoNextScheduleRemunerationMonth" (click)="navigateScheduleRemunerationMonth(1)">Siguiente</button>
          </div>
          <div class="schedule-calendar-mode-toggle" *ngIf="scheduleRemunerationCalendar && !scheduleCalendarIsMonthly" role="tablist" aria-label="Modo visualización calendario">
            <button type="button" role="tab" [class.active]="scheduleCalendarMode === 'calendar'" (click)="setScheduleCalendarMode('calendar')">Modo Calendario</button>
            <button type="button" role="tab" [class.active]="scheduleCalendarMode === 'agenda'" (click)="setScheduleCalendarMode('agenda')">Modo Agenda</button>
          </div>
          <div class="schedule-calendar-area-filter" *ngIf="scheduleRemunerationAreaOptions.length > 1">
            <span>Área</span>
            <button type="button" [class.active]="!selectedScheduleRemunerationAreaKey" (click)="setScheduleRemunerationAreaFilter('')">
              <strong>Todas</strong>
              <b>{{ scheduleRemunerationAreaTotal }}</b>
            </button>
            <button
              type="button"
              *ngFor="let area of scheduleRemunerationAreaOptions"
              [class.active]="selectedScheduleRemunerationAreaKey === area.key"
              (click)="setScheduleRemunerationAreaFilter(area.key)"
            >
              <strong>{{ area.label }}</strong>
              <b>{{ area.total }}</b>
            </button>
          </div>
          <div class="remuneration-calendar-summary">
            <button
              type="button"
              *ngFor="let group of scheduleRemunerationCalendarMonthGroups"
              class="remuneration-calendar-summary-item"
              [ngClass]="[scheduleCalendarGroupClass(group.title), selectedScheduleRemunerationProcessKey === scheduleRemunerationProcessKeyForGroup(group.title) ? 'active' : '']"
              [class.active]="selectedScheduleRemunerationProcessKey === scheduleRemunerationProcessKeyForGroup(group.title)"
              (click)="setScheduleRemunerationProcessFilter(scheduleRemunerationProcessKeyForGroup(group.title))"
            >
              <strong>{{ group.title }}</strong>
              <b>{{ group.events.length }}</b>
            </button>
          </div>
        </section>

        <section class="card schedule-operation-month-card" *ngIf="scheduleRemunerationCalendar && scheduleCalendarIsMonthly">
          <div class="schedule-operation-month-groups">
            <article class="schedule-operation-process" *ngFor="let group of scheduleRemunerationCalendarMonthFilteredGroups" [ngClass]="scheduleCalendarGroupClass(group.title)">
              <div class="schedule-operation-process-head">
                <div>
                  <small>Proceso</small>
                  <h3>{{ group.title }}</h3>
                </div>
                <b>{{ group.events.length }}</b>
              </div>
              <div class="schedule-operation-event-list">
                <button type="button" *ngFor="let event of group.events" [class.active]="isScheduleRemunerationEventActive(event)" (click)="selectScheduleRemunerationEvent(event)">
                  <strong>{{ event.title }}</strong>
                  <span>{{ event.status || event.type }}</span>
                </button>
              </div>
            </article>
          </div>
          <div class="empty-state" *ngIf="!scheduleRemunerationCalendarMonthFilteredGroups.length">Sin hitos para el periodo seleccionado.</div>
        </section>

        <section class="card schedule-calendar-agenda-card" *ngIf="scheduleRemunerationCalendar && !scheduleCalendarIsMonthly && scheduleCalendarMode === 'agenda'">
          <div class="card-head segment-head">
            <div>
              <h2>Agenda del periodo</h2>
              <p>{{ scheduleRemunerationCalendarMonthFilteredEventCount }} hitos filtrados por mes, área y tipo de proceso.</p>
            </div>
          </div>
          <div class="schedule-calendar-agenda">
            <article class="schedule-calendar-agenda-day" *ngFor="let day of scheduleCalendarAgendaDays">
              <div class="schedule-calendar-agenda-date">
                <strong>{{ day.label }}</strong>
                <span>{{ day.events.length }} hito{{ day.events.length === 1 ? '' : 's' }}</span>
              </div>
              <div class="schedule-calendar-agenda-events">
                <button
                  type="button"
                  *ngFor="let event of day.events"
                  [ngClass]="scheduleCalendarEventClass(event)"
                  [class.active]="isScheduleRemunerationEventActive(event)"
                  (click)="selectScheduleRemunerationEvent(event)"
                >
                  <small>{{ event.group }}</small>
                  <strong>{{ event.title }}</strong>
                  <span>{{ event.area || event.type }}</span>
                </button>
              </div>
            </article>
            <div class="empty-state" *ngIf="!scheduleCalendarAgendaDays.length">Sin hitos para la selección actual.</div>
          </div>
        </section>

        <section class="card remuneration-calendar-card schedule-calendar-card" *ngIf="scheduleRemunerationCalendar && !scheduleCalendarIsMonthly && scheduleCalendarMode === 'calendar'">
          <div class="remuneration-calendar-weekdays">
            <span>Lun</span>
            <span>Mar</span>
            <span>Mié</span>
            <span>Jue</span>
            <span>Vie</span>
            <span>Sáb</span>
            <span>Dom</span>
          </div>
          <div class="remuneration-calendar-grid">
            <ng-container *ngFor="let week of scheduleRemunerationCalendarWeeks">
              <div class="remuneration-day" *ngFor="let day of week" [class.blank]="day.blank" [class.has-events]="day.events?.length">
                <ng-container *ngIf="!day.blank">
                  <div class="remuneration-day-top">
                    <strong>{{ day.day }}</strong>
                    <span *ngIf="day.events?.length">{{ day.events.length }} hito{{ day.events.length === 1 ? '' : 's' }}</span>
                  </div>
                  <div class="remuneration-events">
                    <article
                      *ngFor="let event of day.events"
                      [ngClass]="[scheduleCalendarEventClass(event), isScheduleRemunerationEventActive(event) ? 'active' : '']"
                      [attr.title]="event.group + ' · ' + event.title"
                      [class.active]="isScheduleRemunerationEventActive(event)"
                      (click)="$event.stopPropagation(); selectScheduleRemunerationEvent(event)"
                    >
                      <small>{{ event.group }}</small>
                      <b>{{ event.title }}</b>
                    </article>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </section>

        </div>

        <div class="remuneration-event-overlay" data-export-exclude="true" *ngIf="selectedScheduleRemunerationEvent" (click)="closeScheduleRemunerationEvent()">
          <article class="remuneration-event-dialog" [ngClass]="scheduleCalendarEventClass(selectedScheduleRemunerationEvent)" (click)="$event.stopPropagation()">
            <button type="button" class="remuneration-event-close" aria-label="Cerrar" (click)="closeScheduleRemunerationEvent()">×</button>
            <small>{{ selectedScheduleRemunerationEvent.group }}</small>
            <h3>{{ selectedScheduleRemunerationEvent.title }}</h3>
            <div>
              <span>{{ scheduleCalendarEventPeriodLabel(selectedScheduleRemunerationEvent) }}</span>
              <b *ngIf="selectedScheduleRemunerationEvent.type && selectedScheduleRemunerationEvent.type !== '(vacío)'">{{ selectedScheduleRemunerationEvent.type }}</b>
            </div>
          </article>
        </div>
      </ng-container>

      <ng-container *ngIf="scheduleSubView === 'planning'">
        <div id="schedule-planning-export" class="schedule-export-surface">
        <section class="schedule-planning-grid" *ngIf="schedule">
          <article class="card schedule-planning-card schedule-planning-focus">
            <div class="card-head segment-head">
              <div>
                <span class="schedule-eyebrow">Planificación equipo</span>
                <h2>Carga pendiente por proceso</h2>
                <p>{{ scheduleFilterSummary }} · Prioriza los procesos con mayor volumen pendiente.</p>
              </div>
            </div>
            <div class="schedule-planning-process-list">
              <button class="schedule-planning-process" type="button" *ngFor="let process of schedulePlanningTopProcesses" [class.active]="selectedScheduleProcess === process.process" (click)="toggleScheduleProcess(process.process)">
                <div>
                  <strong>{{ process.process }}</strong>
                  <span>{{ process.activities }} actividades · {{ process.monthsCount }} meses activos</span>
                </div>
                <b>{{ process.pending }} pendientes</b>
                <i><em [style.width.%]="process.completion"></em></i>
                <small *ngIf="process.nextPending">Próximo: {{ process.nextPending.monthLabel }} · {{ process.nextPending.activity }}</small>
              </button>
              <div class="empty-state" *ngIf="!schedulePlanningTopProcesses.length">Sin procesos para la selección actual.</div>
            </div>
          </article>

          <article class="card schedule-planning-card schedule-planning-next">
            <div class="card-head segment-head">
              <div>
                <h2>Próximas actividades</h2>
                <p>Hitos pendientes ordenados por mes.</p>
              </div>
            </div>
            <div class="schedule-planning-next-list">
              <button class="schedule-planning-next-item" type="button" *ngFor="let item of schedulePlanningNextActivities" (click)="selectScheduleMilestone(item.month, item.status_key, item.activity)">
                <span>{{ item.monthLabel }}</span>
                <strong>{{ item.activity }}</strong>
                <small>{{ item.process }}</small>
              </button>
              <div class="empty-state" *ngIf="!schedulePlanningNextActivities.length">No hay hitos pendientes para la selección actual.</div>
            </div>
          </article>
        </section>

        <section class="card schedule-planning-matrix-card" *ngIf="schedule">
          <div class="card-head segment-head">
            <div>
              <h2>Matriz de carga proceso/mes</h2>
              <p>Vista compacta para detectar concentración de trabajo y meses sin actividad.</p>
            </div>
            <button type="button" class="schedule-clear" *ngIf="selectedScheduleProcess || selectedScheduleMonth || selectedScheduleStatus || selectedScheduleActivity" (click)="clearScheduleFilters()">Limpiar filtros</button>
          </div>
          <div class="schedule-planning-matrix">
            <div class="schedule-planning-matrix-head">
              <span>Proceso</span>
              <b *ngFor="let month of schedule.months">{{ month.label.slice(0, 3) }}</b>
            </div>
            <div class="schedule-planning-matrix-row" *ngFor="let process of schedulePlanningMatrix">
              <button type="button" [class.active]="selectedScheduleProcess === process.process" (click)="toggleScheduleProcess(process.process)">
                <strong>{{ process.process }}</strong>
                <small>{{ process.pending }} pendientes · {{ process.completion }}%</small>
              </button>
              <button class="schedule-planning-cell" type="button" *ngFor="let cell of process.monthCells" [ngClass]="scheduleStatusClass(cell.status_key)" [class.empty]="!cell.total" [class.active]="selectedScheduleMonth === cell.key" [disabled]="!cell.total" (click)="toggleScheduleMonth(cell.key)">
                <span>{{ cell.total || '' }}</span>
              </button>
            </div>
            <div class="empty-state schedule-empty-row" *ngIf="!schedulePlanningMatrix.length">Sin carga para la selección actual.</div>
          </div>
        </section>
        </div>
      </ng-container>
    </section>
  </ng-container>

  <ng-container *ngIf="activeView === 'freshdesk'">
    <section class="satisfaction-page freshdesk-page segment-card">
      <div class="schedule-hero satisfaction-hero card">
        <div>
          <span class="schedule-eyebrow">Freshdesk API</span>
          <h1>Tickets Freshdesk</h1>
          <p>Conexión preparada contra <code>/api/v2/tickets</code> usando credenciales guardadas en backend.</p>
        </div>
        <div class="satisfaction-controls">
          <label>
            <span>Por página</span>
            <select [ngModel]="freshdeskPerPage" (ngModelChange)="setFreshdeskPerPage($event)">
              <option *ngFor="let value of [10,30,50,100]" [ngValue]="value">{{ value }}</option>
            </select>
          </label>
          <button class="action-button accent satisfaction-refresh" type="button" (click)="loadFreshdesk()">{{ freshdeskLoading ? 'Cargando...' : 'Actualizar' }}</button>
        </div>
      </div>

      <div class="empty-state schedule-error" *ngIf="freshdeskError">{{ freshdeskError }}</div>

      <section class="satisfaction-kpis">
        <article class="schedule-metric-card">
          <small>Página</small>
          <strong>{{ freshdeskPage }}</strong>
        </article>
        <article class="schedule-metric-card">
          <small>Tickets cargados</small>
          <strong>{{ formatNumber(freshdeskItems.length) }}</strong>
        </article>
        <article class="schedule-metric-card">
          <small>Dominio</small>
          <strong class="freshdesk-domain">{{ freshdesk?.domain || '—' }}</strong>
        </article>
        <article class="schedule-metric-card">
          <small>Estado</small>
          <strong>{{ freshdeskLoading ? '...' : (freshdeskError ? 'Error' : 'Listo') }}</strong>
        </article>
      </section>

      <section class="card table-card satisfaction-table-card">
        <div class="table-head">
          <div>
            <h2>Tickets</h2>
            <p>Listado inicial desde Freshdesk.</p>
          </div>
          <div class="freshdesk-pager">
            <button class="ghost-button" type="button" [disabled]="freshdeskPage <= 1" (click)="setFreshdeskPage(-1)">Anterior</button>
            <button class="ghost-button" type="button" (click)="setFreshdeskPage(1)">Siguiente</button>
          </div>
        </div>
        <div class="table-scroll">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Asunto</th>
                <th>Estado</th>
                <th>Prioridad</th>
                <th>Tipo</th>
                <th>Creado</th>
                <th>Actualizado</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of freshdeskItems">
                <td>{{ item.id }}</td>
                <td>{{ item.subject }}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.priority }}</td>
                <td>{{ item.type }}</td>
                <td>{{ item.created_at }}</td>
                <td>{{ item.updated_at }}</td>
              </tr>
              <tr *ngIf="!freshdeskItems.length">
                <td colspan="7" class="empty-state">{{ freshdeskLoading ? 'Cargando tickets...' : 'Configura FRESHDESK_DOMAIN y FRESHDESK_API_KEY para cargar tickets.' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </section>
  </ng-container>

  <ng-container *ngIf="activeView === 'satisfaction'">
    <section class="satisfaction-page segment-card">
      <div class="schedule-hero satisfaction-hero card card-head segment-head">
        <div>
          <h2>Encuesta satisfacción</h2>
          <p>Resultados consultados desde la API de satisfacción PowerBI del Centro de Servicio.</p>
          <small class="satisfaction-updated-at" *ngIf="satisfactionLastUpdated">Última actualización: {{ satisfactionLastUpdated }}</small>
        </div>
        <div class="satisfaction-controls">
          <button class="action-button accent satisfaction-refresh" type="button" (click)="loadSatisfaction()">{{ satisfactionLoading ? 'Cargando...' : 'Actualizar' }}</button>
        </div>
      </div>

      <div class="empty-state schedule-error" *ngIf="satisfactionError">{{ satisfactionError }}</div>

      <div class="topics-window-bar operations-period-bar operations-period-top satisfaction-period-bar">
        <span class="window-current">{{ satisfactionWindowLabel }}</span>
        <div class="topic-window-options satisfaction-window-options">
          <button type="button" *ngFor="let option of satisfactionWindowOptions" [class.active]="selectedSatisfactionWindow === option.value" (click)="setSatisfactionWindow(option.value)">
            {{ option.label }}
          </button>
        </div>
      </div>

      <section class="satisfaction-filter-bar card satisfaction-banner-filters">
        <div class="satisfaction-filter-grid">
          <label>
            <span>Año</span>
            <select [ngModel]="selectedSatisfactionYear" (ngModelChange)="setSatisfactionSelectFilter('year', $event)">
              <option value="">Todos</option>
              <option *ngFor="let year of satisfactionYearOptions" [value]="year">{{ year }}</option>
            </select>
          </label>
          <label>
            <span>Mes</span>
            <select [ngModel]="selectedSatisfactionMonth" (ngModelChange)="setSatisfactionSelectFilter('month', $event)">
              <option value="">Todos</option>
              <option *ngFor="let month of satisfactionMonthOptions" [value]="month.key">{{ month.label }}</option>
            </select>
          </label>
          <label>
            <span>Área</span>
            <select [ngModel]="selectedSatisfactionArea" (ngModelChange)="setSatisfactionSelectFilter('area', $event)">
              <option value="">Todas</option>
              <option *ngFor="let area of satisfactionAreaOptions" [value]="area.key">{{ area.label }}</option>
            </select>
          </label>
          <label>
            <span>Responsable</span>
            <select [ngModel]="selectedSatisfactionResponsable" (ngModelChange)="setSatisfactionSelectFilter('responsable', $event)">
              <option value="">Todos</option>
              <option *ngFor="let responsable of satisfactionResponsableOptions" [value]="responsable.key">{{ responsable.label }}</option>
            </select>
          </label>
          <label>
            <span>Nota</span>
            <select [ngModel]="selectedSatisfactionScore" (ngModelChange)="setSatisfactionSelectFilter('score', $event)">
              <option value="">Todas</option>
              <option *ngFor="let score of satisfactionScoreOptions" [value]="score">{{ score }}</option>
            </select>
          </label>
          <button class="action-button ghost satisfaction-clear" type="button" [disabled]="!satisfactionFilterActive" (click)="clearSatisfactionFilters()">Limpiar</button>
        </div>
        <div class="satisfaction-segment-filter satisfaction-segment-banner">
          <span>Segmento</span>
          <div>
            <button type="button" [class.active]="selectedSatisfactionCategory === ''" (click)="selectSatisfactionCategory('')">Todos</button>
            <button type="button" [class.active]="selectedSatisfactionCategory === 'promoters'" (click)="selectSatisfactionCategory('promoters')">Promotores</button>
            <button type="button" [class.active]="selectedSatisfactionCategory === 'passives'" (click)="selectSatisfactionCategory('passives')">Neutros</button>
            <button type="button" [class.active]="selectedSatisfactionCategory === 'detractors'" (click)="selectSatisfactionCategory('detractors')">Detractores</button>
          </div>
        </div>
      </section>

      <section class="satisfaction-kpis">
        <article class="schedule-metric-card">
          <small>Encuestas</small>
          <strong>{{ formatNumber(satisfactionSummary.total || 0) }}</strong>
        </article>
        <article class="schedule-metric-card">
          <small>Respondidas</small>
          <strong>{{ formatNumber(satisfactionSummary.answered || 0) }}</strong>
        </article>
        <article class="schedule-metric-card">
          <small>Nota promedio</small>
          <strong>{{ satisfactionSummary.average ?? '—' }}</strong>
        </article>
        <article class="schedule-metric-card">
          <small>NPS</small>
          <strong>{{ satisfactionSummary.nps ?? '—' }}</strong>
        </article>
      </section>

      <section class="satisfaction-board">
        <article class="card satisfaction-tile satisfaction-nps-mix-tile">
          <div class="card-head segment-head satisfaction-tile-head">
            <div>
              <h2>Distribución respuestas NPS</h2>
              <p>Promotores, neutros y detractores</p>
            </div>
          </div>
          <div class="satisfaction-distribution-layout">
            <div class="satisfaction-distribution-side">
              <div class="satisfaction-pie-wrap">
                <div class="satisfaction-pie" [style.--promoter]="satisfactionPromoterPct + '%'" [style.--passive]="satisfactionPassivePct + '%'" aria-label="Distribución NPS">
                  <div>
                    <strong>{{ satisfactionSummary.nps ?? '—' }}</strong>
                    <span>NPS</span>
                  </div>
                </div>
              </div>
              <div class="satisfaction-summary-list">
                <div class="promoters">
                  <i class="promoter"></i>
                  <span>Promotores - {{ formatNumber(satisfactionSummary.promoters || 0) }}</span>
                  <strong>{{ satisfactionPromoterPct }}%</strong>
                </div>
                <div class="passives">
                  <i class="passive"></i>
                  <span>Neutros - {{ formatNumber(satisfactionSummary.passives || 0) }}</span>
                  <strong>{{ satisfactionPassivePct }}%</strong>
                </div>
                <div class="detractors">
                  <i class="detractor"></i>
                  <span>Detractores - {{ formatNumber(satisfactionSummary.detractors || 0) }}</span>
                  <strong>{{ satisfactionDetractorPct }}%</strong>
                </div>
              </div>
            </div>
            <div class="satisfaction-distribution-side">
              <div class="satisfaction-pie-wrap">
                <div class="satisfaction-pie note" [style.--note]="satisfactionScoreWidth(satisfactionSummary.average) + '%'" aria-label="Nota promedio">
                  <div>
                    <strong>{{ satisfactionSummary.average ?? '—' }}</strong>
                    <span>Nota</span>
                  </div>
                </div>
              </div>
              <div class="satisfaction-summary-list">
                <div><span>Envíos</span><strong>{{ formatNumber(satisfactionItems.length) }}</strong></div>
                <div><span>Respuestas</span><strong>{{ formatNumber(filteredSatisfactionItems.length) }}</strong></div>
                <div><span>Tasa</span><strong>{{ satisfactionSummary.answered ? ((satisfactionSummary.answered / (satisfactionItems.length || 1)) * 100).toFixed(1) : '0.0' }}%</strong></div>
              </div>
            </div>
          </div>
          <div class="satisfaction-score-mini">
            <div class="satisfaction-score-mini-head">
              <span>Q por nota</span>
              <strong>{{ formatNumber(satisfactionSummary.answered || 0) }}</strong>
            </div>
            <div class="satisfaction-behavior-mini" aria-label="Comportamiento de respuesta">
              <button type="button" class="satisfaction-note-column" *ngFor="let row of satisfactionScoreDistribution" [ngClass]="satisfactionCategory(row.score)" [class.active]="selectedSatisfactionScore === '' + row.score" [title]="row.score + ': ' + row.value" (click)="selectSatisfactionScore(row.score)">
                <strong>{{ formatNumber(row.value) }}</strong>
                <i><em [style.height.%]="row.pct"></em></i>
                <span>{{ row.score }}</span>
              </button>
            </div>
          </div>
        </article>

        <article class="card chart-card satisfaction-trend-tile">
          <div class="card-head segment-head">
            <div>
              <h2>Tendencia NPS</h2>
              <p>{{ selectedSatisfactionArea || 'Todas las áreas' }} · {{ selectedSatisfactionResponsable || 'Todos los responsables' }}</p>
            </div>
            <div class="segmented-control satisfaction-window-toggle">
              <button class="segmented" type="button" *ngFor="let option of satisfactionTrendWindows" [class.active]="satisfactionTrendWindow === option.value" (click)="setSatisfactionTrendWindow(option.value)">{{ option.label }}</button>
            </div>
          </div>
          <div class="trend-list trend-chart satisfaction-trend-chart" *ngIf="satisfactionTrendRows.length; else noSatisfactionTrend">
            <div class="trend-legend">
              <button type="button" [class.active]="selectedSatisfactionTrendMetric === 'promoters'" [class.dimmed]="selectedSatisfactionTrendMetric && selectedSatisfactionTrendMetric !== 'promoters'" (click)="selectSatisfactionTrendMetric('promoters')"><i class="dot teal"></i>Promotores</button>
              <button type="button" [class.active]="selectedSatisfactionTrendMetric === 'passives'" [class.dimmed]="selectedSatisfactionTrendMetric && selectedSatisfactionTrendMetric !== 'passives'" (click)="selectSatisfactionTrendMetric('passives')"><i class="dot violet"></i>Neutros</button>
              <button type="button" [class.active]="selectedSatisfactionTrendMetric === 'detractors'" [class.dimmed]="selectedSatisfactionTrendMetric && selectedSatisfactionTrendMetric !== 'detractors'" (click)="selectSatisfactionTrendMetric('detractors')"><i class="dot red"></i>Detractores</button>
              <button type="button" [class.active]="selectedSatisfactionTrendMetric === 'average'" [class.dimmed]="selectedSatisfactionTrendMetric && selectedSatisfactionTrendMetric !== 'average'" (click)="selectSatisfactionTrendMetric('average')"><i class="dot period-b"></i>Nota</button>
              <button type="button" [class.active]="selectedSatisfactionTrendMetric === 'nps'" [class.dimmed]="selectedSatisfactionTrendMetric && selectedSatisfactionTrendMetric !== 'nps'" (click)="selectSatisfactionTrendMetric('nps')"><i class="dot satisfaction-nps-dot"></i>NPS</button>
              <button type="button" [class.active]="selectedSatisfactionTrendMetric === 'surveys'" [class.dimmed]="selectedSatisfactionTrendMetric && selectedSatisfactionTrendMetric !== 'surveys'" (click)="selectSatisfactionTrendMetric('surveys')"><i class="dot satisfaction-surveys-dot"></i>Encuestas</button>
            </div>
            <div class="trend-line-wrap" (mouseleave)="clearSatisfactionTrendHover()">
              <div class="satisfaction-trend-scroll">
                <div class="satisfaction-trend-inner" [style.width.px]="satisfactionTrendChartWidth">
                  <svg class="trend-line-svg satisfaction-trend-svg" [attr.viewBox]="'0 0 ' + satisfactionTrendChartWidth + ' 240'" role="img" aria-label="Tendencia mensual NPS">
                    <line class="trend-grid-line" x1="4" y1="22" [attr.x2]="satisfactionTrendChartWidth - 4" y2="22"></line>
                    <line class="trend-grid-line" x1="4" y1="84" [attr.x2]="satisfactionTrendChartWidth - 4" y2="84"></line>
                    <line class="trend-grid-line" x1="4" y1="147" [attr.x2]="satisfactionTrendChartWidth - 4" y2="147"></line>
                    <line class="trend-grid-line strong" x1="4" y1="210" [attr.x2]="satisfactionTrendChartWidth - 4" y2="210"></line>
                    <path class="trend-line closed satisfaction-line-promoters" *ngIf="showSatisfactionTrendMetric('promoters')" [attr.d]="satisfactionTrendCategoryPath('promoters')"></path>
                    <path class="trend-line backlog satisfaction-line-passives" *ngIf="showSatisfactionTrendMetric('passives')" [attr.d]="satisfactionTrendCategoryPath('passives')"></path>
                    <path class="trend-line received satisfaction-line-detractors" *ngIf="showSatisfactionTrendMetric('detractors')" [attr.d]="satisfactionTrendCategoryPath('detractors')"></path>
                    <path class="trend-line satisfaction-line-average" *ngIf="showSatisfactionTrendMetric('average')" [attr.d]="satisfactionTrendAveragePath"></path>
                    <path class="trend-line satisfaction-line-nps" *ngIf="showSatisfactionTrendMetric('nps')" [attr.d]="satisfactionTrendNpsPath"></path>
                    <path class="trend-line satisfaction-line-surveys" *ngIf="showSatisfactionTrendMetric('surveys')" [attr.d]="satisfactionTrendSurveysPath"></path>
                    <line class="trend-hover-line" *ngIf="satisfactionTrendActivePoint" [attr.x1]="satisfactionTrendHoverX" y1="22" [attr.x2]="satisfactionTrendHoverX" y2="210"></line>
                    <rect class="trend-hitbox" x="4" y="14" [attr.width]="satisfactionTrendChartWidth - 8" height="210" (mousemove)="onSatisfactionTrendPointer($event)" (pointerdown)="onSatisfactionTrendPointer($event)"></rect>
                  </svg>
                  <div class="trend-tooltip" *ngIf="satisfactionTrendActivePoint" [class.left-edge]="satisfactionTrendTooltipPositionClass === 'left-edge'" [class.right-edge]="satisfactionTrendTooltipPositionClass === 'right-edge'" [style.left.%]="satisfactionTrendTooltipLeftPct">
                    <strong class="trend-tooltip-date">
                      <span>{{ satisfactionTrendActivePoint.label }}</span>
                      <small>| {{ formatNumber(satisfactionTrendActivePoint.answered || 0) }} respuestas</small>
                    </strong>
                    <em>Mueve el cursor para recorrer períodos</em>
                    <span class="tooltip-metric satisfaction-note"><i></i>Nota <b>{{ satisfactionTrendActivePoint.average ?? '—' }}</b></span>
                    <span class="tooltip-metric satisfaction-nps"><i></i>NPS <b>{{ satisfactionTrendActivePoint.nps ?? '—' }}</b></span>
                    <span class="tooltip-metric satisfaction-surveys"><i></i>Encuestas <b>{{ formatNumber(satisfactionTrendActivePoint.answered || 0) }}</b></span>
                    <span class="tooltip-metric teal"><i></i>Promotores <b>{{ satisfactionPct(satisfactionTrendActivePoint, 'promoters') }}%</b></span>
                    <span class="tooltip-metric violet"><i></i>Neutros <b>{{ satisfactionPct(satisfactionTrendActivePoint, 'passives') }}%</b></span>
                    <span class="tooltip-metric red"><i></i>Detractores <b>{{ satisfactionPct(satisfactionTrendActivePoint, 'detractors') }}%</b></span>
                  </div>
                  <div class="trend-axis satisfaction-trend-axis">
                    <span class="trend-axis-label static" *ngFor="let point of satisfactionTrendRows">
                      <span class="axis-date">{{ point.label }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-template #noSatisfactionTrend>
            <div class="empty-state">Sin periodos suficientes para graficar.</div>
          </ng-template>
        </article>

        <article class="card satisfaction-tile satisfaction-people-tile">
          <div class="card-head segment-head satisfaction-list-head">
            <div>
              <h2>Áreas y responsables</h2>
              <p>Selecciona una fila para filtrar la sección.</p>
            </div>
          </div>
          <div class="satisfaction-people-grid">
            <section>
              <div class="satisfaction-subhead">
                <span>Áreas</span>
                <strong>{{ formatNumber(satisfactionAreaBars.length) }}</strong>
              </div>
              <div class="satisfaction-performance-list">
                <button type="button" *ngFor="let area of satisfactionAreaBars" [class.active]="selectedSatisfactionArea === area.key" (click)="selectSatisfactionFilter('area', area.key)">
                  <div class="satisfaction-person-main">
                    <strong>{{ area.label }}</strong>
                    <span>{{ formatNumber(area.answered) }} respuestas · {{ area.pct }}% del filtro</span>
                  </div>
                  <div class="satisfaction-person-kpis">
                    <span class="note-kpi" [ngClass]="satisfactionCategory(area.average)"><small>Nota</small><b>{{ area.average ?? '—' }}</b></span>
                    <span><small>NPS</small><b>{{ area.nps ?? '—' }}</b></span>
                    <span><small>Prom.</small><b>{{ satisfactionPct(area, 'promoters') }}%</b></span>
                    <span><small>Detr.</small><b>{{ satisfactionPct(area, 'detractors') }}%</b></span>
                  </div>
                  <i [ngClass]="area.dominantCategory"><em [style.width.%]="area.pct"></em></i>
                </button>
              </div>
            </section>
            <section>
              <div class="satisfaction-subhead">
                <span>Responsables</span>
                <strong>{{ formatNumber(satisfactionResponsableBars.length) }}</strong>
              </div>
              <div class="satisfaction-performance-list">
                <button type="button" *ngFor="let responsable of satisfactionResponsableBars" [class.active]="selectedSatisfactionResponsable === responsable.key" (click)="selectSatisfactionFilter('responsable', responsable.key)">
                  <div class="satisfaction-person-main">
                    <strong>{{ responsable.label }}</strong>
                    <span>{{ formatNumber(responsable.answered) }} respuestas · {{ responsable.pct }}% del filtro</span>
                  </div>
                  <div class="satisfaction-person-kpis">
                    <span class="note-kpi" [ngClass]="satisfactionCategory(responsable.average)"><small>Nota</small><b>{{ responsable.average ?? '—' }}</b></span>
                    <span><small>NPS</small><b>{{ responsable.nps ?? '—' }}</b></span>
                    <span><small>Prom.</small><b>{{ satisfactionPct(responsable, 'promoters') }}%</b></span>
                    <span><small>Detr.</small><b>{{ satisfactionPct(responsable, 'detractors') }}%</b></span>
                  </div>
                  <i [ngClass]="responsable.dominantCategory"><em [style.width.%]="responsable.pct"></em></i>
                </button>
              </div>
            </section>
          </div>
        </article>

      </section>

      <section class="card table-card satisfaction-table-card">
        <div class="card-head table-head segment-head">
          <div>
            <h2>Respuestas</h2>
            <p>{{ formatNumber(sortedSatisfactionResponseItems.length) }} de {{ formatNumber(filteredSatisfactionItems.length) }} respuestas filtradas · Mostrando {{ formatNumber(satisfactionResponsesPageStart) }}-{{ formatNumber(satisfactionResponsesPageEnd) }}</p>
          </div>
          <div class="satisfaction-responses-toolbar">
            <div class="satisfaction-responses-segments" aria-label="Filtrar respuestas por segmento">
              <button class="promoters" type="button" [class.active]="selectedSatisfactionResponseSegment === 'promoters'" (click)="selectSatisfactionResponseSegment('promoters')">Promotor</button>
              <button class="passives" type="button" [class.active]="selectedSatisfactionResponseSegment === 'passives'" (click)="selectSatisfactionResponseSegment('passives')">Neutro</button>
              <button class="detractors" type="button" [class.active]="selectedSatisfactionResponseSegment === 'detractors'" (click)="selectSatisfactionResponseSegment('detractors')">Detractor</button>
            </div>
          </div>
        </div>
        <div class="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Ticket</th>
                <th>Correo</th>
                <th>Área</th>
                <th>Responsable</th>
                <th>Nota</th>
                <th>Segmento</th>
                <th>Fecha</th>
                <th>Respuesta</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of satisfactionResponsesPageItems; trackBy: trackBySatisfactionItem">
                <td>
                  <a class="ticket-id-link" [href]="freshdeskTicketUrl(item.id_ticket)" target="_blank" rel="noopener noreferrer">{{ item.id_ticket }}</a>
                </td>
                <td>{{ item.correo_ticket }}</td>
                <td>{{ item.area }}</td>
                <td>{{ item.responsable }}</td>
                <td>
                  <div class="satisfaction-score">
                    <span>{{ item.nota ?? '—' }}</span>
                    <i [ngClass]="satisfactionCategory(item.nota)"><em [style.width.%]="satisfactionScoreWidth(item.nota)"></em></i>
                  </div>
                </td>
                <td><span class="satisfaction-segment-pill" [ngClass]="satisfactionCategory(item.nota)">{{ satisfactionCategoryLabel(item.nota) }}</span></td>
                <td>{{ satisfactionDateOnly(item.fecha) }}</td>
                <td>{{ item.respuesta }}</td>
              </tr>
              <tr *ngIf="!satisfactionResponsesPageItems.length">
                <td colspan="8" class="empty-state">{{ satisfactionLoading ? 'Cargando encuesta...' : (satisfaction ? 'Sin respuestas para el filtro aplicado.' : 'Presiona Actualizar para cargar la encuesta.') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="satisfaction-responses-pager">
          <button class="ghost-button" type="button" [disabled]="satisfactionResponsesPage === 0" (click)="goToSatisfactionResponsesPage(0)">Primera</button>
          <button class="ghost-button" type="button" [disabled]="satisfactionResponsesPage === 0" (click)="goToSatisfactionResponsesPage(satisfactionResponsesPage - 1)">Anterior</button>
          <div class="satisfaction-page-numbers">
            <button type="button" *ngFor="let pageNumber of satisfactionResponsesPageNumbers" [class.active]="satisfactionResponsesPage === pageNumber" [disabled]="satisfactionResponsesTotalPages <= 1" (click)="goToSatisfactionResponsesPage(pageNumber)">
              {{ pageNumber + 1 }}
            </button>
          </div>
          <button class="ghost-button" type="button" [disabled]="satisfactionResponsesPage >= satisfactionResponsesTotalPages - 1" (click)="goToSatisfactionResponsesPage(satisfactionResponsesPage + 1)">Siguiente</button>
          <button class="ghost-button" type="button" [disabled]="satisfactionResponsesPage >= satisfactionResponsesTotalPages - 1" (click)="goToSatisfactionResponsesPage(satisfactionResponsesTotalPages - 1)">Última</button>
        </div>
      </section>
    </section>
  </ng-container>

  <ng-container *ngIf="activeView === 'documents'">
    <div class="view-documents-content" *ngIf="!documentsLoading && documents && !documentsError; else docLoadingOrError">
      <header class="doc-header">
        <span class="schedule-eyebrow">Biblioteca documental RH</span>
        <h1>Documentos</h1>
        <p class="doc-subtitle">Tablero vivo de seguimiento documental por área definida.</p>
        <small class="doc-meta" *ngIf="documents.updated_at">
          Actualizado: {{ documents.updated_at }} &middot; {{ documents.source?.official }}
        </small>
      </header>

      <section class="card doc-total-status doc-fuente-tabs">
        <div class="doc-control-layout doc-control-summary-layout">
          <div class="doc-control-main">
            <div class="doc-control-main-head">
              <div>
                <strong>Control Documentos</strong>
                <small>{{ docControlSubtitle }}</small>
              </div>
              <button class="doc-filter-clear" *ngIf="selectedDocKpi" type="button" (click)="applyDocKpi('')">Limpiar KPI</button>
            </div>

            <div class="doc-priority-kpis doc-summary-kpis">
              <button class="doc-priority-kpi" type="button" *ngFor="let card of docControlSummaryKpis" [class.active]="selectedDocKpi === card.key && isDocKpiFilterable(card.key)" [class.no-filter]="!isDocKpiFilterable(card.key)" [class.status-done]="card.tone === 'ready'" [class.status-pending]="card.tone === 'warning'" [class.status-risk]="card.tone === 'risk'" [class.status-info]="card.tone === 'info'" (click)="isDocKpiFilterable(card.key) && applyDocKpi(card.key)">
                <span class="doc-source-pill" *ngIf="card.badge" [ngClass]="{'official': card.badge === 'IA', 'pending': card.badge === 'Sugerencia', 'risk-pill': card.badge === 'Riesgo', 'physical-pill': card.badge === 'Físico'}">{{ card.badge }}</span>
                <strong>{{ card.value }}</strong>
                <small>{{ card.label }}</small>
                <span class="doc-summary-note">{{ card.note }}</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <div class="doc-blocks-row">
        <section class="card doc-block doc-block-full">
          <div class="card-head">
            <span>Seguimiento por área</span>
            <small>Documentos activos por revisar o integrar</small>
          </div>
          <div class="card-body">
            <div class="doc-area-grid">
              <button class="doc-area-card" type="button" *ngFor="let area of documentAreaTracking" [class.active]="selectedDocumentArea === area.area" (click)="selectDocumentArea(area.area)">
                <div class="doc-area-card-head">
                  <span class="doc-area-name">{{ area.area }}</span>
                </div>
                <strong>{{ area.total_documentos }}</strong>
                <span>{{ area.avance_clasificacion_pct }}% clasificación</span>
                <div class="doc-mini-bar"><div class="doc-mini-fill" [style.width.%]="area.avance_clasificacion_pct"></div></div>
                <div class="doc-area-tags">
                  <span>Requiere revisión: {{ area.requieren_revision }}</span>
                  <span>Pendiente: {{ area.propuestas_pendientes }}</span>
                  <span *ngIf="area.duplicados_asociados">Duplicados asociados: {{ area.duplicados_asociados }}</span>
                </div>
              </button>
            </div>
          </div>
        </section>
      </div>

      <div class="doc-blocks-row" *ngIf="selectedDocumentAreaDetail as areaDetail">
        <section class="card doc-block doc-block-full">
          <div class="card-head">
            <span>Detalle por área · {{ areaDetail.area }}</span>
            <small>Base documental del área en estado pendiente de validación</small>
          </div>
          <div class="card-body">
            <div class="doc-detail-metrics">
              <div><strong>{{ areaDetail.documentos_confirmados.length }}</strong><span>Documentos del área</span></div>
              <div><strong>{{ areaDetail.propuestas_pendientes_validar.length }}</strong><span>Propuestas integradas</span></div>
              <div><strong>{{ areaDetail.documentos_sin_responsable.length }}</strong><span>Sin responsable</span></div>
              <div><strong>{{ areaDetail.documentos_desactualizados.length }}</strong><span>Con meses sin actualización</span></div>
              <div><strong>{{ areaDetail.documentos_requieren_revision.length }}</strong><span>Requieren revisión</span></div>
              <div><strong>{{ areaDetail.promedio_meses_sin_actualizacion || 0 }}</strong><span>Prom. meses sin act.</span></div>
            </div>

            <div class="doc-area-detail-columns">
              <div>
                <h3><span class="doc-source-pill pending">Pendiente</span> Documentos por validar</h3>
                <div class="doc-compact-list">
                  <button type="button" *ngFor="let doc of areaDetail.documentos_confirmados.slice(0, 8)" (click)="openDocumentDetail(doc)">
                    <span>{{ doc.Documento }}</span>
                    <small>{{ doc.ID }} · {{ doc.Estado || 'Pendiente de validar' }}</small>
                  </button>
                </div>
              </div>
              <div>
                <h3><span class="doc-source-pill pending">Propuesta</span> Reclasificaciones integradas</h3>
                <div class="doc-compact-list pending">
                  <div *ngFor="let item of areaDetail.propuestas_pendientes_validar.slice(0, 8)">
                    <span>{{ item.Documento }}</span>
                    <small>{{ item.ID }} · {{ item['Área actual'] }} → {{ item['Área sugerida'] }}</small>
                  </div>
                </div>
              </div>
              <div>
                <h3>Checklist futuro</h3>
                <ul class="doc-checklist">
                  <li *ngFor="let item of areaDetail.checklist_futuro">{{ item }}</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section class="card doc-block doc-block-full doc-segmentation-panel">
        <div class="card-head">
          <span>Segmentación documental</span>
          <small>Desglose por tipo documental sobre documentos activos por revisar o integrar.</small>
        </div>
        <div class="card-body">
          <div class="doc-segmentation-summary">
            <div>
              <strong>{{ docTypeSegmentTotal }}</strong>
              <span>A revisar visibles</span>
            </div>
            <div>
              <strong>{{ docTypeSegments.length }}</strong>
              <span>Tipos detectados</span>
            </div>
            <div>
              <strong>{{ docFilterTipo.length ? docFilterTipo[0] : 'Todos' }}</strong>
              <span>Tipo activo</span>
            </div>
          </div>

          <div class="doc-segment-grid">
            <button class="doc-segment-card" type="button" *ngFor="let segment of docTypeSegments" [class.active]="docFilterTipo.includes(segment.tipo)" (click)="applyDocTypeSegment(segment.tipo)">
              <div class="doc-segment-card-head">
                <span>{{ segment.tipo }}</span>
                <strong>{{ segment.total }}</strong>
              </div>
              <p class="doc-segment-context">
                <span>{{ docFilterTipo.includes(segment.tipo) ? docActiveRows.length : segment.total }} visibles</span>
                <span>Total tipo {{ docOfficialTypeTotal(segment.tipo) }}</span>
              </p>
              <div class="doc-segment-bar"><span [style.width.%]="segment.pct"></span></div>
              <div class="doc-segment-meta">
                <span>{{ segment.pct }}%</span>
                <span *ngIf="segment.pendientes">Pend. {{ segment.pendientes }}</span>
              </div>
            </button>
          </div>
        </div>
      </section>

      <div class="doc-blocks-row doc-library-insights">
        <section class="card doc-block doc-block-full">
          <div class="card-head">
            <span>Actualización de carpetas</span>
            <small>Ruta destino por área y estado de avance de la unificación física</small>
          </div>
          <div class="card-body">
            <div class="doc-folder-physical-summary">
              <div *ngFor="let item of documentFolderUpdateStatusItems" [ngClass]="'tone-' + item.tone">
                <strong>{{ formatNumber(item.value || 0) }}</strong>
                <span>{{ item.label }}</span>
              </div>
            </div>
            <div class="doc-folder-table-wrap" *ngIf="documentFolderUpdateAreas.length">
              <table class="doc-group-table doc-folder-table">
                <thead><tr><th>Área</th><th>Total</th><th>Act.</th><th>Revisión</th><th>Dep.</th><th>Físico</th><th>Dif.</th><th>Pend.</th><th>Carpeta destino</th></tr></thead>
                <tbody>
                  <tr *ngFor="let item of documentFolderUpdateAreas">
                    <td class="doc-group-name">{{ item.area }}</td>
                    <td>{{ item.total }}</td>
                    <td>{{ item.actualizados }}</td>
                    <td>{{ item.archivos_por_revisar }}</td>
                    <td>{{ item.archivos_depurados || 0 }}</td>
                    <td>{{ item.total_fisico_controlado || 0 }}</td>
                    <td>{{ item.diferencia_excel_fisico || 0 }}</td>
                    <td>{{ item.pendientes_actualizacion }}</td>
                    <td><small>{{ item.ruta_carpeta_destino }}</small></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>

      <section class="card doc-block doc-block-full doc-duplicates-section" *ngIf="duplicateMap.length || duplicateReviewSummary.registros">
        <div class="card-head">
          <span>Mapa de duplicados y versiones</span>
          <small>Mapa operativo de grupos pendientes. Los grupos listos para consolidar salen de esta lista y quedan solo en el avance histórico.</small>
        </div>
        <div class="card-body">
          <div class="doc-duplicate-review-summary">
            <div>
              <strong>{{ formatNumber(duplicateReviewSummary.grupos_activos || 0) }}</strong>
              <span>Grupos activos</span>
            </div>
            <div>
              <strong>{{ formatNumber(duplicateReviewSummary.grupos_listos_consolidar || 0) }}</strong>
              <span>Grupos depurados</span>
            </div>
            <div>
              <strong>{{ formatNumber(duplicateReviewSummary.registros_activos || 0) }}</strong>
              <span>Registros activos</span>
            </div>
            <div>
              <strong>{{ formatNumber(duplicateReviewSummary.pendientes_activos || 0) }}</strong>
              <span>Pendientes activos</span>
            </div>
            <div>
              <strong>{{ formatNumber(duplicateReviewSummary.duplicados_confirmados || 0) }}</strong>
              <span>Duplicados históricos</span>
            </div>
            <div>
              <strong>{{ formatPercent(duplicateReviewSummary.avance_pct || 0) }}</strong>
              <span>Avance revisión</span>
            </div>
          </div>
          <div class="doc-duplicates-layout">
            <div class="doc-duplicate-panel doc-duplicate-areas">
              <h3>Área</h3>
              <button class="doc-duplicate-area-card" type="button" *ngFor="let area of duplicateAreaSummary" [class.active]="activeDuplicateArea === area.area" (click)="selectDuplicateArea(area.area)">
                <span>{{ area.area }}</span>
                <strong>{{ area.registros }}</strong>
                <small>{{ area.revisados || 0 }} revisados · {{ area.pendientes || 0 }} pendientes · {{ formatPercent(area.avance_revision_pct || 0) }}</small>
              </button>
            </div>

            <div class="doc-duplicate-panel doc-duplicates-list">
              <h3>Documentos duplicados activos</h3>
              <button class="doc-duplicate-group" type="button" *ngFor="let group of filteredDuplicateMap" [class.active]="selectedDuplicateGroup?.clave === group.clave" (click)="selectDuplicateGroup(group.clave)">
                <span>{{ group.documento_principal || group.clave }}</span>
                <strong>{{ group.total }}</strong>
                <small>{{ group.estado_revision }} · {{ group.revisados || 0 }}/{{ group.total }} revisados · {{ formatPercent(group.avance_revision_pct || 0) }}</small>
              </button>
              <div class="empty-state" *ngIf="!filteredDuplicateMap.length">Sin documentos duplicados activos para el área.</div>
            </div>

            <div class="doc-duplicate-panel doc-duplicate-detail" *ngIf="selectedDuplicateGroup as duplicateGroup">
              <div class="doc-duplicate-detail-head">
                <div>
                  <span class="doc-source-pill">Detalle</span>
                  <h3>{{ duplicateGroup.documento_principal || duplicateGroup.clave }}</h3>
                  <p>{{ duplicateGroup.estado_revision }} · {{ duplicateGroup.revisados || 0 }} de {{ duplicateGroup.total }} revisados · {{ duplicateGroup.versiones_vigentes || 0 }} versión vigente · {{ duplicateGroup.no_correspondian || 0 }} no correspondían</p>
                </div>
              </div>
              <div class="doc-table-wrap compact">
                <table class="doc-queue-table">
                  <thead><tr><th>Documento</th><th>Ubicación</th><th>Revisión</th><th>Acción</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let item of duplicateGroup.items">
                      <td><span class="doc-name-cell" title="{{ item.ruta }}">{{ item.documento }}</span></td>
                      <td><small class="doc-location-cell" title="{{ item.ruta }}">{{ item.ruta || '-' }}</small></td>
                      <td>
                        <span class="doc-review-pill" *ngIf="item.estado_revision_codigo !== 'pendiente'" [ngClass]="duplicateReviewClass(item)">{{ item.estado_revision }}</span>
                        <div class="doc-review-actions">
                          <button type="button" *ngFor="let option of duplicateReviewOptions" [class.active]="item.estado_revision_codigo === option.value" [disabled]="duplicateReviewSavingKey === item.item_key" (click)="setDuplicateReview(duplicateGroup, item, option.value)" [title]="option.label">{{ option.short }}</button>
                        </div>
                      </td>
                      <td><small>{{ item.accion_sugerida || '-' }}</small></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="card doc-block doc-block-full">
        <div class="card-head">
          <span *ngIf="docFilterFuente === 'oficial' || docFilterFuente === 'todas'">Listado dinámico de documentos</span>
          <span *ngIf="docFilterFuente === 'sugerencia'">Sugerencias de reclasificación</span>
          <small *ngIf="selectedDocKpi">Filtro activo: {{ docKpiLabel(selectedDocKpi) }} · <button class="doc-filter-clear" type="button" (click)="applyDocKpi('')">Limpiar</button></small>
          <small *ngIf="!selectedDocKpi">{{ docActiveRows.length }} registros visibles</small>
        </div>
        <div class="card-body">
          <div class="doc-filter-bar">
            <input class="doc-search" type="search" [ngModel]="docFilterBusqueda" (ngModelChange)="docFilterBusqueda = $event; requestDocRefresh()" placeholder="Buscar en vista activa...">
            <button class="doc-filter-clear" *ngIf="docFilterActive('estado') || docFilterActive('tipo') || docFilterActive('grupo') || docFilterActive('responsable') || docFilterActive('prioridad') || docFilterBusqueda" type="button" (click)="clearDocFilters()">Limpiar</button>
          </div>

          <!-- Tabla de documentos -->
          <div class="doc-table-wrap" *ngIf="(docFilterFuente === 'oficial' || docFilterFuente === 'todas') && docActiveRows.length; else noOficialRows">
            <table class="doc-queue-table">
              <thead><tr><th>ID</th><th>Documento</th><th>Área</th><th>Estado</th><th>Responsable</th><th>Tipo</th><th>Proceso / acción</th><th>Antigüedad</th><th></th></tr></thead>
              <tbody>
                <tr *ngFor="let row of docActiveRows.slice(0, 80)" [class.doc-outdated]="isDocDesactualizado(row)">
                  <td><span class="doc-name-cell">{{ row.ID }}</span></td>
                  <td>
                    <button class="doc-name-cell" type="button" (click)="openDocumentDetail(row)" title="Ver detalle">{{ row.Documento }}</button>
                    <span class="doc-duplicate-badge" *ngIf="isDocDuplicado(row)" title="{{ row['Duplicado / versión'] }}">Duplicado</span>
                    <span class="doc-sugerencia-badge" *ngIf="row['Sugerencia automatización'] && row['Sugerencia automatización'] !== '(vacío)'" title="{{ row['Sugerencia automatización'] }}">Mejora</span>
                  </td>
                  <td><span class="doc-source-pill" style="font-size:10px;padding:2px 6px;">{{ row['Área oficial'] || row['Área sugerida'] || '-' }}</span></td>
                  <td><span class="status-badge" [class.status-pending-badge]="row.Estado === 'Pendiente'" [class.status-done-badge]="row.Estado === 'Revisado inicial'">{{ row.Estado }}</span></td>
                  <td>{{ row.Responsable || '-' }}</td>
                  <td><small>{{ getCanonicalDocType(row) || '-' }}</small></td>
                  <td><small>{{ row['Proceso oficial'] || row['Acción sugerida'] || '-' }}</small></td>
                  <td class="text-risk" *ngIf="isDocDesactualizado(row)">{{ row['Meses sin actualización'] || '>12' }}</td>
                  <td *ngIf="!isDocDesactualizado(row)">{{ row['Meses sin actualización'] || '-' }}</td>
                  <td><button class="ghost-button" type="button" (click)="openDocumentDetail(row)">Detalle</button></td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noOficialRows><div class="empty-state" *ngIf="docFilterFuente === 'oficial' || docFilterFuente === 'todas'">Sin documentos para los filtros activos.</div></ng-template>

          <!-- Tabla sugerencias -->
          <div class="doc-table-wrap" *ngIf="docFilterFuente === 'sugerencia' && docActiveRows.length; else noSugerenciaRows">
            <table class="doc-queue-table">
              <thead><tr><th>ID</th><th>Documento</th><th>Área actual</th><th>Área sugerida</th><th>Confianza</th><th>Motivo</th><th>Fuente</th><th>Observaciones</th><th>Acción</th></tr></thead>
              <tbody>
                <tr *ngFor="let row of docActiveRows.slice(0, 80)">
                  <td>{{ row.ID }}</td>
                  <td><button class="doc-name-cell" type="button" (click)="openDocumentDetail(row)" title="Ver detalle">{{ row.Documento }}</button></td>
                  <td>{{ row['Área actual'] }}</td>
                  <td><span class="doc-source-pill official" style="font-size:10px;padding:2px 6px;">{{ row['Área sugerida'] }}</span></td>
                  <td><span class="status-badge" [class.status-done-badge]="row.Confianza === 'Alta'" [class.status-pending-badge]="row.Confianza === 'Media'" [class.status-risk-badge]="row.Confianza === 'Baja'">{{ row.Confianza }}</span></td>
                  <td><small>{{ row.Motivo }}</small></td>
                  <td>{{ row['Fuente de señal'] }}</td>
                  <td><small class="doc-mejora-cell" title="{{ row['Observaciones validación'] }}">{{ row['Observaciones validación'] ? (row['Observaciones validación'].length > 30 ? row['Observaciones validación'].slice(0, 30) + '…' : row['Observaciones validación']) : '-' }}</small></td>
                  <td><small>{{ row['Acción sugerida'] }}</small></td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noSugerenciaRows><div class="empty-state" *ngIf="docFilterFuente === 'sugerencia'">Sin sugerencias para el filtro activo.</div></ng-template>

          <div class="doc-filter-clear-bar" *ngIf="selectedDocKpi || docFilterFuente !== 'todas'">
            <button class="ghost-button" type="button" (click)="applyDocKpi(''); setDocFuente('todas')">Restablecer vista completa</button>
          </div>
        </div>
      </section>

    </div>

    <ng-template #docLoadingOrError>
      <section class="card documents-placeholder segment-card" *ngIf="documentsLoading">
        <h1>Biblioteca documental RH</h1>
        <p>Cargando seguimiento documental...</p>
      </section>
      <section class="card documents-placeholder segment-card" *ngIf="documentsError && !documentsLoading">
        <h1>Biblioteca documental RH</h1>
        <p class="text-risk">{{ documentsError }}</p>
        <button class="ghost-button" type="button" (click)="loadDocuments(true)">Reintentar</button>
      </section>
    </ng-template>

    <div class="doc-modal-overlay" *ngIf="selectedDocument" (click)="closeDocumentDetail()">
      <div class="doc-modal" (click)="$event.stopPropagation()">
        <button class="doc-modal-close" type="button" (click)="closeDocumentDetail()">&times;</button>
        <div class="doc-modal-head">
          <h2>{{ selectedDocument.Documento || selectedDocument['Nombre archivo'] || 'Sin nombre' }}</h2>
          <span class="doc-modal-id">Documento · ID: {{ selectedDocument.ID || selectedDocument['ID coincidencia Excel'] || '-' }}</span>
        </div>
          <div class="doc-modal-body">
          <div class="doc-modal-field"><span class="label">Área definida / sugerida</span><span>{{ selectedDocument['Área oficial'] || selectedDocument['Área sugerida'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Confianza</span><span>{{ selectedDocument['Confianza área'] || selectedDocument.Confianza || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Requiere revisión</span><span>{{ selectedDocument['Requiere revisión área'] || selectedDocument['Requiere revisión humana'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Tipo / categoría</span><span>{{ selectedDocument['Tipo estimado'] || selectedDocument['Categoría sugerida'] || selectedDocument['Tipo archivo'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Grupo</span><span>{{ selectedDocument.Grupo || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Responsable</span><span>{{ selectedDocument.Responsable || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Estado</span><span>{{ selectedDocument.Estado || selectedDocument['Estado evaluación Freshdesk'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Prioridad</span><span>{{ selectedDocument.Prioridad || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Área / carpeta</span><span>{{ selectedDocument['Area / carpeta'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Ruta carpeta destino</span><span>{{ selectedDocument['Ruta carpeta destino'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Estado carpeta actualizada</span><span>{{ selectedDocument['Estado carpeta actualizada'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Ruta carpeta por revisar</span><span>{{ selectedDocument['Ruta carpeta por revisar'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Estado carpeta por revisar</span><span>{{ selectedDocument['Estado carpeta por revisar'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Estado IA</span><span>{{ selectedDocument['Estado IA'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Proceso</span><span>{{ selectedDocument['Proceso oficial'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Extensión</span><span>{{ selectedDocument.Extension || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Fecha modificación</span><span>{{ selectedDocument['Fecha modificacion'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Fecha actualización carpeta</span><span>{{ selectedDocument['Fecha actualización carpeta'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Meses sin actualización</span><span>{{ selectedDocument['Meses sin actualización'] || '-' }}</span></div>
          <div class="doc-modal-field doc-modal-field-full">
            <span class="label">Ruta completa</span>
            <span class="doc-path">{{ selectedDocument['Ruta completa'] || '-' }}</span>
          </div>
          <div class="doc-modal-field doc-modal-field-full">
            <span class="label">Sugerencia / acción</span>
            <span>{{ selectedDocument['Sugerencia automatización'] || selectedDocument['Acción sugerida'] || '-' }}</span>
          </div>
          <div class="doc-modal-section-head">Validación</div>
          <div class="doc-modal-field"><span class="label">Estado validación</span><span>{{ selectedDocument['Estado validación propuesta'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Decisión usuario</span><span>{{ selectedDocument['Decisión usuario'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Duplicado / versión</span><span>{{ selectedDocument['Duplicado / versión'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Documento principal</span><span>{{ selectedDocument['Documento principal relacionado'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">Fecha decisión</span><span>{{ selectedDocument['Fecha decisión'] || '-' }}</span></div>
          <div class="doc-modal-field"><span class="label">ID doc. creado</span><span>{{ selectedDocument['ID documento creado/relacionado'] || '-' }}</span></div>
          <div class="doc-modal-field doc-modal-field-full">
            <span class="label">Acción requerida</span>
            <span>{{ selectedDocument['Acción requerida'] || '-' }}</span>
          </div>
          <div class="doc-modal-field doc-modal-field-full">
            <span class="label">Motivo asignación área</span>
            <span>{{ selectedDocument['Motivo asignación área'] || '-' }}</span>
          </div>
          <div class="doc-modal-field doc-modal-field-full" *ngIf="docCalendarLink.length">
            <span class="label">Relación calendario</span>
            <div class="doc-cal-links">
              <div class="doc-cal-item" *ngFor="let cal of docCalendarLink">
                <span>{{ cal.detalle || cal.documento }}</span>
                <small>{{ cal.fecha }} &middot; {{ cal.tipo }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
